export const data = {
  "cooperflorabarao": {
    "group": {
      "address": "Armazém do Campo - Espaço agroecológico ",
      "name": "Barão Geraldo",
      "deliveryWeekDay": "Quarta-feira",
      "notice": "Alguma observação",
      "deliveryFrequencyInDays": 15,
      "deliveryFrequencyText": "Quinzenalmente às quartas-feiras",
      "baseProductsPrice": 45,
      "deliveryFee": 6,
      "consumers": 206,
      "date": "Fri Jun 19 2026 20:32:30 GMT-0300 (Brasilia Standard Time)"
    },
    "extraProducts": [
      " CESTA PEQUENA",
      "Abacate",
      "Abacaxi",
      "Abiu",
      "Abobrinha",
      "Abobrinha G",
      "Abóbora",
      "Abóbora  inteira (7 reais por kg)",
      "Acerola",
      "Alecrim",
      "Alface",
      "Alho-poró",
      "Almeirão",
      "Amendoim",
      "Arroz Branco agulhinha  5kg",
      "Arroz Cateto integral 1 kg",
      "Arroz Parborizado 1kg",
      "Arroz branco 1kg",
      "Arroz integral 1kg",
      "Azeite 250 ml",
      "Azeite 300 ml",
      "Azeite 500 ml",
      "Açafrão grão",
      "Açafrão moído ",
      "Açúcar mascavo",
      "Açúcar mascavo ",
      "Babosa",
      "Banana 1 kg",
      "Batata Doce",
      "Berinjela",
      "Beterraba",
      "Bolacha da vovo",
      "Bolacha de aveia",
      "Bolinho de Chuva",
      "Bolo de cenoura",
      "Bolo de cenoura com cobertura",
      "Bolo de fubá com erva doce",
      "Bolo de goiaba ",
      "Bolo de laranja",
      "Bolo de limão",
      "Bolo de mandioca",
      "Bolo de milho",
      "Bone LGBT",
      "Boné MST",
      "Boné Simples ",
      "Bonés bordados",
      "Broa de fubá 100g ",
      "Broa de fubá 300g",
      "Brócolis ",
      "Bucha",
      "Cachaça 300 ml",
      "Cachaça Socialista",
      "Cachaça amburana",
      "Cachaça carvalho",
      "Cachaça cubana",
      "Cachaça jequitibá rosa",
      "Cachaça prata",
      "Cachaça vida seca",
      "Cachaças",
      "Café Cecília (grãos)",
      "Café Cecília (moído)",
      "Café Guai",
      "Café Terra de Sabores Extraforte",
      "Café Terra de Sabores Tradicional",
      "Café Terra de sabores 250g",
      "Cajamanga",
      "Caju",
      "Camiseta MST",
      "Capim santo",
      "Cará",
      "Caxi",
      "Caxixe",
      "Cebola 500g",
      "Cebolinha",
      "Cenoura",
      "Cheiro Verde",
      "Chicória",
      "Chuchu",
      "Coentro",
      "Colorau (100g)",
      "Colorau 150g",
      "Conserva Pimenta Dedo de Moça 300 ml",
      "Conserva de pimenta (G)",
      "Conserva de pimenta (M)",
      "Conserva pimenta cumari 170g",
      "Conserva pimenta dedo de moça 550ml",
      "Contribuição de Natal 🎄",
      "Couve",
      "Couve (inteira / picada)",
      "Doce de Goiaba",
      "Doce de Leite",
      "Doce de Leite com Mamão",
      "Doce de abobora ",
      "Doce de banana",
      "Doce de banana mista",
      "Doce de manga",
      "Doce de manga com abobora",
      "Doce de manga grande",
      "Erva-cidreira",
      "Erva-doce folhas ",
      "Espinafre",
      "Farinha de Mandioca 🌱",
      "Farinha de mandioca (normal) 1kg",
      "Farinha de mandioca Lió 500g",
      "Farinha de mandioca artesanal 1 kg",
      "Farinha de mandioca puba",
      "Feijão carioca 1Kg",
      "Feijão guandu 500g",
      "Feijão preto 1 kg",
      "Flocão de Milho 500 gr",
      "Frango Caipirão",
      "Frango caipira",
      "Fubá de milho 1kg",
      "Geleia abóbora com manga",
      "Geleia de abacaxi com pimenta",
      "Geleia de amora",
      "Geleia de cajamanga",
      "Geleia de frutas picantes",
      "Geleia de goiaba",
      "Geleia de mamão com cajá manga",
      "Geleia de manga",
      "Geleia de manga com cajamanga",
      "Geleia de manga com maracujá ",
      "Geleia de manga picante",
      "Geleia de pimenta ",
      "Geleia de uva",
      "Geleia haidi",
      "Geleias (outros sabores)",
      "Hortelã",
      "Hortelã pimenta",
      "Inhame",
      "Jabuticaba",
      "Jiló",
      "Levante",
      "Lichia",
      "Limão ",
      "Malagueta com cachaça",
      "Mamão Verde",
      "Mamão inteiro ",
      "Mandioca (com casca)",
      "Mandioca sem casca",
      "Manga",
      "Manjericão",
      "Maracujá",
      "Maxixe",
      "Mel (300ml)",
      "Melissa",
      "Milho 1/2 dz",
      "Milho 12 und",
      "Milho de Pipoca",
      "Molho de Pimenta 150ML",
      "Molho de Tomate",
      "Molho de pimenta grande",
      "Nabo",
      "Nózinho de Coco",
      "Ora-pro-nobis",
      "Orégano",
      "Ovos (dúzia)sujeito pouco estoque ",
      "Pepino (em natura)",
      "Picles (Conserva)",
      "Pimenta Cambuci",
      "Pimenta Dedo de Moça 300ml",
      "Pimenta biquinho",
      "Pimenta comari",
      "Pimenta do Reino em grãos ",
      "Pimenta do reino moída",
      "Pimenta em conserva",
      "Pimentão",
      "Pipoca 1kg",
      "Pitaya",
      "Pitomba 350gr ",
      "Poupa Maracujá Cong",
      "Pão comum",
      "Pão de beterraba",
      "Pão de fubá ",
      "Pão de mandioca",
      "Pão integral",
      "Queijo Fresco G",
      "Queijo Fresco P",
      "Queijo Meia Cura G",
      "Queijo meia cura 1/2 P",
      "Quiabo",
      "Rabanete",
      "Repolho ",
      "Rifa",
      "Rifa Juninho ",
      "Rosca de Côco com recheio de goiabada",
      "Rosquinha recheada de goiabada",
      "Rúcula",
      "Sabonete de Argila Branca",
      "Sabonete de Argila Rosa",
      "Sabonete de Argila Verde",
      "Sabonete de Argila Vermelha",
      "Salsao",
      "Salsinha",
      "Suco de goiaba 1L",
      "Suco de manga",
      "Suco de maçã 1L",
      "Suco de uva 1,5 litro",
      "Suco de uva 1L",
      "Sucos 1 litro",
      "Taioba",
      "Tempero Caseiro",
      "Tempero caseiro coentro",
      "Tempero caseiro pimenta",
      "Tempero caseiro salsinha",
      "Tempero caseiro tradicional",
      "Tomate",
      "Tomatinho",
      "Vagem",
      "Vinagre Aromat. / Agridoce",
      "Vinho"
    ],
    "deliveries": [
      {
        "deliveryId": "lpzVOoa1EFg0JgcPc4dp",
        "date": "2022-01-20",
        "dateText": "19/01/2022",
        "cestas": 10,
        "totalAmountBaseProductsSale": 450,
        "extraProducts": [
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Banana",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Broa de Milho",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Tomatinho",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Abacaxi",
            "amount": 1,
            "price": 5
          },
          {
            "name": "Berinjela",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Maracujá",
            "amount": 1,
            "price": 5
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Suco de manga, maça e tangerina (1 sabor)",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Espinafre",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pão integral",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Feijão 1Kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Flocão de Milho",
            "amount": 1,
            "price": 8
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Maxixe",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 20
          }
        ],
        "totalAmountExtraProductsSales": 402
      },
      {
        "deliveryId": "RUehZtnhBy5JTpdDKwAR",
        "date": "2022-02-03",
        "dateText": "02/02/2022",
        "cestas": null,
        "totalAmountBaseProductsSale": null,
        "extraProducts": [
          {
            "name": "Abóbora moranga inteira (6 reais por kg)",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 5,
            "price": 12
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 7,
            "price": 12
          },
          {
            "name": "Berinjela",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Couve",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Manga",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 6,
            "price": 32
          },
          {
            "name": "Suco de uva 1L",
            "amount": 4,
            "price": 17
          },
          {
            "name": "Abacaxi",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Tomatinho",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Abóbora",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Tomate",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Broa de Milho",
            "amount": 3,
            "price": 10
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Rosquinha de Côco",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Açafrão ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 1,
            "price": 8
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Mel (300ml)",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Queijo Fresco P",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 5
          },
          {
            "name": "Açúcar mascavo",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 38
          },
          {
            "name": "Pão branco",
            "amount": 2,
            "price": 10
          }
        ],
        "totalAmountExtraProductsSales": 1113
      },
      {
        "deliveryId": "YaPqzpCoeUcYogMpFdFR",
        "date": "2022-02-17",
        "dateText": "16/02/2022",
        "cestas": 13,
        "totalAmountBaseProductsSale": 585,
        "extraProducts": [
          {
            "name": "Abacaxi",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Milho",
            "amount": 6,
            "price": 7.5
          },
          {
            "name": "Queijo Fresco P",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Acerola",
            "amount": 3,
            "price": 5
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Hortelã",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Mel (300ml)",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Suco de uva 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 25
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Broa de Milho",
            "amount": 4,
            "price": 10
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Rosquinha de Côco com recheio de goiabada",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 32
          },
          {
            "name": "Cachaça carvalho",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Feijão 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Pão branco",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Tomate",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          }
        ],
        "totalAmountExtraProductsSales": 711
      },
      {
        "deliveryId": "5MAkx7LaNlqs7AfSMtLo",
        "date": "2022-03-03",
        "dateText": "02/03/2022",
        "cestas": 15,
        "totalAmountBaseProductsSale": 675,
        "extraProducts": [
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Hortelã",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Mel (300ml)",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Queijo Fresco G",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 3,
            "price": 32
          },
          {
            "name": "Suco de uva 1L",
            "amount": 6,
            "price": 17
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Abacaxi",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Açúcar mascavo",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Broa de Milho",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Queijo Fresco P",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Malagueta com cachaça",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Molho de Tomate",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Bolo de laranja",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Melissa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 10
          }
        ],
        "totalAmountExtraProductsSales": 863
      },
      {
        "deliveryId": "3TOq7v9RFth2DOkxXMbc",
        "date": "2022-03-17",
        "dateText": "16/03/2022",
        "cestas": 35,
        "totalAmountBaseProductsSale": 1575,
        "extraProducts": [
          {
            "name": "Pão de mandioca",
            "amount": 8,
            "price": 12
          },
          {
            "name": "Tomatinho",
            "amount": 9,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 2,
            "price": 8
          },
          {
            "name": "Bolo de mandioca",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Alfavaca",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Bolo de goiaba ",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Bolo de milho",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Melissa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Ora-pro-nobis",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 6,
            "price": 15
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 6,
            "price": 32
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Açúcar mascavo",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Mandioca sem casca",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Pão integral",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Bolo de laranja",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Broa de Milho",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Maracujá",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cheiro Verde",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Mel (300ml)",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Pão branco",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Pimenta do reino moída",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Pimenta",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Fresco G",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 3,
            "price": 25
          },
          {
            "name": "Banana",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 1,
            "price": 15
          }
        ],
        "totalAmountExtraProductsSales": 1247
      },
      {
        "deliveryId": "mi9tgYrYioiI43IGq1ZQ",
        "date": "2022-04-07",
        "dateText": "06/04/2022",
        "cestas": 33,
        "totalAmountBaseProductsSale": 1485,
        "extraProducts": [
          {
            "name": "Café Cecília (moído)",
            "amount": 5,
            "price": 25
          },
          {
            "name": "Couve",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Maracujá",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Suco de manga, maça e tangerina (1 sabor)",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Molho de Tomate",
            "amount": 3,
            "price": 25
          },
          {
            "name": "Pimenta do reino moída",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 11,
            "price": 20
          },
          {
            "name": "Abóbora",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Bolo de mandioca",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 4,
            "price": 22
          },
          {
            "name": "Broa de Milho",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Açúcar mascavo",
            "amount": 3,
            "price": 13
          },
          {
            "name": "Cachaça Socialista",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Cachaça camponeses ",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Cachaça amburana",
            "amount": 5,
            "price": 40
          },
          {
            "name": "Quiabo",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Sacola (\"Eco bag\")",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Mel (300ml)",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Acerola",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de goiaba ",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Ora-pro-nobis",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cachaça prata",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Feijão 1Kg",
            "amount": 5,
            "price": 15
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Flocão de Milho",
            "amount": 3,
            "price": 8
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Alface",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pão branco",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Bolo de laranja",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 14
          }
        ],
        "totalAmountExtraProductsSales": 1564
      },
      {
        "deliveryId": "IiOXCuMEuHfUkwCnGZPf",
        "date": "2022-04-21",
        "dateText": "20/04/2022",
        "cestas": 25,
        "totalAmountBaseProductsSale": 1125,
        "extraProducts": [
          {
            "name": "Pão de mandioca",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Feijão 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 4,
            "price": 32
          },
          {
            "name": "Broa de Milho",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Couve",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Molho de Pimenta",
            "amount": 3,
            "price": 10
          },
          {
            "name": "Quiabo",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Rúcula",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 5,
            "price": 25
          },
          {
            "name": "Abacate",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Beterraba",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Flocão de Milho",
            "amount": 4,
            "price": 8
          },
          {
            "name": "Mamão",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Mel (300ml)",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Pão branco",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Rosquinha de Côco com recheio de goiabada",
            "amount": 2,
            "price": 18
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro pimenta",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Cachaça prata",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Arroz Cateto 1 kg",
            "amount": 2,
            "price": 14
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Pão integral",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Queijo Fresco P",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Suco de uva 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Bolo de laranja",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Bolo de mandioca",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Fresco G",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Molho de Tomate",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Ora-pro-nobis",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1353
      },
      {
        "deliveryId": "IMNPmlAElVo33ROOeyS5",
        "date": "2022-05-05",
        "dateText": "04/05/2022",
        "cestas": 36,
        "totalAmountBaseProductsSale": 1620,
        "extraProducts": [
          {
            "name": "Berinjela",
            "amount": 12,
            "price": 6
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 3,
            "price": 25
          },
          {
            "name": "Feijão 1Kg",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Pão de mandioca",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Rúcula",
            "amount": 11,
            "price": 6
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 5,
            "price": 22
          },
          {
            "name": "Flocão de Milho",
            "amount": 3,
            "price": 8
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Molho de Pimenta",
            "amount": 5,
            "price": 10
          },
          {
            "name": "Cheiro Verde",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Cachaça Socialista",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Couve",
            "amount": 11,
            "price": 6
          },
          {
            "name": "Nabo",
            "amount": 2,
            "price": 5
          },
          {
            "name": "Bolo de milho",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de laranja",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Broa de Milho",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Arroz Cateto 1 kg",
            "amount": 3,
            "price": 14
          },
          {
            "name": "Bolo de goiaba ",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Suco de uva 1L",
            "amount": 5,
            "price": 17
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Babosa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de mandioca",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Tempero caseiro pimenta",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Tomate",
            "amount": 3,
            "price": 25
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Melissa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de manga, maça e tangerina (1 sabor)",
            "amount": 1,
            "price": 17
          }
        ],
        "totalAmountExtraProductsSales": 1409
      },
      {
        "deliveryId": "MBbAPP1jtGbilpMkONUH",
        "date": "2022-05-19",
        "dateText": "18/05/2022",
        "cestas": 27,
        "totalAmountBaseProductsSale": 1215,
        "extraProducts": [
          {
            "name": "Alho-poró",
            "amount": 10,
            "price": 6
          },
          {
            "name": "Bolo de milho",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Bucha",
            "amount": 6,
            "price": 5
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 5,
            "price": 25
          },
          {
            "name": "Coentro",
            "amount": 6,
            "price": 5
          },
          {
            "name": "Espinafre",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Melissa",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 8,
            "price": 12
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Banana",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Beterraba",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Mamão",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Pimentão",
            "amount": 3,
            "price": 5
          },
          {
            "name": "Queijo Fresco G",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Suco de manga, maça e tangerina (1 sabor)",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Feijão 1Kg",
            "amount": 5,
            "price": 15
          },
          {
            "name": "Cachaça Socialista",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Doce de Leite",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Açúcar mascavo",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Cachaça 300 ml",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 3,
            "price": 17
          },
          {
            "name": "Berinjela",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Pimenta",
            "amount": 3,
            "price": 10
          },
          {
            "name": "Suco de uva 1L",
            "amount": 10,
            "price": 15
          },
          {
            "name": "Nabo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Açafrão",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Cenoura",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 3,
            "price": 32
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Queijo Fresco P",
            "amount": 5,
            "price": 15
          },
          {
            "name": "Quiabo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tomatinho",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Flocão de Milho",
            "amount": 1,
            "price": 8
          },
          {
            "name": "Broa de Milho",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Erva-cidreira",
            "amount": 2,
            "price": 5
          },
          {
            "name": "Hortelã",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Cachaça prata",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Bolo de goiaba ",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Ora-pro-nobis",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 1693
      },
      {
        "deliveryId": "emuCbbvmS1tlGVxRtuCp",
        "date": "2022-06-02",
        "dateText": "01/06/2022",
        "cestas": 29,
        "totalAmountBaseProductsSale": 1305,
        "extraProducts": [
          {
            "name": "Banana",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Berinjela",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 7,
            "price": 15
          },
          {
            "name": "Abóbora",
            "amount": 9,
            "price": 6
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz Cateto 1 kg",
            "amount": 2,
            "price": 14
          },
          {
            "name": "Beterraba",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 5,
            "price": 8
          },
          {
            "name": "Hortelã",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Pão integral",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Tomatinho",
            "amount": 10,
            "price": 6
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 10,
            "price": 25
          },
          {
            "name": "Chuchu",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Coentro",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 8,
            "price": 20
          },
          {
            "name": "Mamão",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Suco de manga, maça e tangerina (1 sabor)",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Broa de Milho",
            "amount": 7,
            "price": 12
          },
          {
            "name": "Pão de mandioca",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Batata Doce",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Salsinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Geleia de amora",
            "amount": 3,
            "price": 14
          },
          {
            "name": "Ora-pro-nobis",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Suco de uva 1L",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Feijão 1Kg",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Quiabo",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Abacate",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Geleia de uva",
            "amount": 2,
            "price": 14
          },
          {
            "name": "Melissa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pão branco",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Doce de Leite",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Cachaça amburana",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cachaça carvalho",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Malagueta com cachaça",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Açúcar mascavo",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Mamão Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 32
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Espinafre",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          }
        ],
        "totalAmountExtraProductsSales": 1728
      },
      {
        "deliveryId": "khccsbeCx0wphS5t2Ibs",
        "date": "2022-06-16",
        "dateText": "15/06/2022",
        "cestas": 35,
        "totalAmountBaseProductsSale": 1575,
        "extraProducts": [
          {
            "name": "Couve",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Geleia de goiaba",
            "amount": 4,
            "price": 10
          },
          {
            "name": "Pão branco",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Vinagre Aromat. / Agridoce",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Amendoim",
            "amount": 16,
            "price": 7
          },
          {
            "name": "Bolo de laranja",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Flocão de Milho",
            "amount": 4,
            "price": 8
          },
          {
            "name": "Jiló",
            "amount": 4,
            "price": 5
          },
          {
            "name": "Pão integral",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Alho-poró",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 2,
            "price": 14
          },
          {
            "name": "Cheiro Verde",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Queijo Fresco G",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Suco de manga, maça e tangerina (1 sabor)",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Feijão 1Kg",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Queijo Fresco P",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Molho de Pimenta",
            "amount": 5,
            "price": 10
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Pão de mandioca",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 25
          },
          {
            "name": "Alecrim",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Batata Doce",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Broa de Milho",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Hortelã pimenta",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Tomatinho",
            "amount": 9,
            "price": 6
          },
          {
            "name": "Bolo de milho",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Abóbora",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Banana",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Colorau 150g",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Limão ",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Coentro",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          }
        ],
        "totalAmountExtraProductsSales": 1218
      },
      {
        "deliveryId": "Hte8jOmqfb6mPlRvBXFA",
        "date": "2022-07-07",
        "dateText": "06/07/2022",
        "cestas": 35,
        "totalAmountBaseProductsSale": 1575,
        "extraProducts": [
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Batata Doce",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Jiló",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 4,
            "price": 32
          },
          {
            "name": "Tomatinho",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cará",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 7,
            "price": 15
          },
          {
            "name": "Mamão Verde",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 7,
            "price": 12
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 15,
            "price": 25
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 8,
            "price": 20
          },
          {
            "name": "Alecrim",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Cebolinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Coentro",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Molho de Tomate",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Tempero Caseiro",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Vinho",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Bolo de milho",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Pão branco",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Cheiro Verde",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Banana",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Melissa",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 8,
            "price": 15
          },
          {
            "name": "Salsinha",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Amendoim",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Flocão de Milho",
            "amount": 6,
            "price": 8
          },
          {
            "name": "Rifa",
            "amount": 10,
            "price": 20
          },
          {
            "name": "Broa de Milho",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Mamão",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Abóbora",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Mel (300ml)",
            "amount": 5,
            "price": 15
          },
          {
            "name": "Bolo de goiaba ",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 3,
            "price": 14
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Repolho ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Sucos 1 litro",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Bolo de laranja",
            "amount": 2,
            "price": 20
          }
        ],
        "totalAmountExtraProductsSales": 2305
      },
      {
        "deliveryId": "zvkloZYaVjQ63jRXJWbl",
        "date": "2022-07-21",
        "dateText": "20/07/2022",
        "cestas": 33,
        "totalAmountBaseProductsSale": 1485,
        "extraProducts": [
          {
            "name": "Pão de mandioca",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Alho-poró",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 9,
            "price": 15
          },
          {
            "name": "Queijo Fresco P",
            "amount": 7,
            "price": 18
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 3,
            "price": 14
          },
          {
            "name": "Beterraba",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Bolo de milho",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 9,
            "price": 25
          },
          {
            "name": "Chicória",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Jiló",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Queijo Fresco G",
            "amount": 1,
            "price": 32
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Boné MST",
            "amount": 4,
            "price": 35
          },
          {
            "name": "Broa de Milho",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Cachaça prata",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Camiseta MST",
            "amount": 2,
            "price": 50
          },
          {
            "name": "Pimentão",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Pão branco",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Bone LGBT",
            "amount": 1,
            "price": 70
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 4,
            "price": 35
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Banana",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Doce de Leite",
            "amount": 3,
            "price": 13
          },
          {
            "name": "Molho de Pimenta",
            "amount": 3,
            "price": 10
          },
          {
            "name": "Bolo de laranja",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Limão ",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Amendoim",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 8,
            "price": 22
          },
          {
            "name": "Hortelã pimenta",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Tomate",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mamão Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Capim santo",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Cachaça carvalho",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Rifa",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Berinjela",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cenoura",
            "amount": 3,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 2156
      },
      {
        "deliveryId": "lsBqMoJNe8O0ZxpOo7D2",
        "date": "2022-08-04",
        "dateText": "03/08/2022",
        "cestas": 38,
        "totalAmountBaseProductsSale": 1710,
        "extraProducts": [
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Mel (300ml)",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Banana",
            "amount": 9,
            "price": 6
          },
          {
            "name": "Chicória",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 5,
            "price": 35
          },
          {
            "name": "Bolo de milho",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Cachaça prata",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Pão de mandioca",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Alho-poró",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Bolo de laranja",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Broa de Milho",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 6,
            "price": 13
          },
          {
            "name": "Geleia de amora",
            "amount": 3,
            "price": 14
          },
          {
            "name": "Queijo Fresco P",
            "amount": 5,
            "price": 18
          },
          {
            "name": "Hortelã",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 5,
            "price": 20
          },
          {
            "name": "Berinjela",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Rifa",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Coentro",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Açúcar mascavo",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Jiló",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Pimenta",
            "amount": 3,
            "price": 10
          },
          {
            "name": "Queijo Fresco G",
            "amount": 3,
            "price": 32
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 3,
            "price": 17
          },
          {
            "name": "Abacate",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Maracujá",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Açafrão ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Amendoim",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 1496
      },
      {
        "deliveryId": "rpePhuL7oq1iXsCWhdqk",
        "date": "2022-08-18",
        "dateText": "17/08/2022",
        "cestas": 32,
        "totalAmountBaseProductsSale": 1440,
        "extraProducts": [
          {
            "name": "Pão de mandioca",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 4,
            "price": 14
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Coentro",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 9,
            "price": 15
          },
          {
            "name": "Mel (300ml)",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Rifa",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 6,
            "price": 20
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Beterraba",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 3,
            "price": 8
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Pão integral",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de laranja",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Rosquinha recheada de goiabada",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Nózinho de Coco",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Repolho ",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Açúcar mascavo",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Bolo de milho",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Vagem",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Erva-cidreira",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Abóbora",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Espinafre",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Hortelã",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pão branco",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Limão ",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Tomatinho",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Cachaça prata",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          }
        ],
        "totalAmountExtraProductsSales": 1228
      },
      {
        "deliveryId": "F6qffgFpxppLsxJGTRaW",
        "date": "2022-09-08",
        "dateText": "07/09/2022",
        "cestas": 45,
        "totalAmountBaseProductsSale": 2025,
        "extraProducts": [
          {
            "name": "Alho-poró",
            "amount": 12,
            "price": 6
          },
          {
            "name": "Berinjela",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Pão branco",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 5,
            "price": 30
          },
          {
            "name": "Molho de Tomate",
            "amount": 3,
            "price": 25
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Suco de uva 1L",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Geleia haidi",
            "amount": 12,
            "price": 20
          },
          {
            "name": "Tomatinho",
            "amount": 9,
            "price": 6
          },
          {
            "name": "Bolo de goiaba ",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 11,
            "price": 30
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 4,
            "price": 10
          },
          {
            "name": "Bolo de cenoura",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Feijão 1Kg",
            "amount": 6,
            "price": 15
          },
          {
            "name": "Mandioca sem casca",
            "amount": 11,
            "price": 7
          },
          {
            "name": "Chicória",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Espinafre",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 9,
            "price": 12
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 4,
            "price": 40
          },
          {
            "name": "Flocão de Milho",
            "amount": 11,
            "price": 8
          },
          {
            "name": "Bolo de milho",
            "amount": 4,
            "price": 20
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Broa de Milho",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Rosca de Côco com recheio de goiabada",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 4,
            "price": 14
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Pão integral",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Rosquinha recheada de goiabada",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Molho de Pimenta",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Geleia de amora",
            "amount": 4,
            "price": 14
          },
          {
            "name": "Mel (300ml)",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 7,
            "price": 20
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Hortelã",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de laranja",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Cheiro Verde",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Erva-cidreira",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro pimenta",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Almeirão",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Açúcar mascavo",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 2625
      },
      {
        "deliveryId": "VdktDqzHU1sqOebA4CPY",
        "date": "2022-09-22",
        "dateText": "21/09/2022",
        "cestas": 41,
        "totalAmountBaseProductsSale": 1845,
        "extraProducts": [
          {
            "name": "Espinafre",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Hortelã",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Pão integral",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Queijo Fresco P",
            "amount": 5,
            "price": 18
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 6,
            "price": 20
          },
          {
            "name": "Tomatinho",
            "amount": 11,
            "price": 6
          },
          {
            "name": "Rosquinha recheada de goiabada",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Chicória",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Geleia haidi",
            "amount": 7,
            "price": 20
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 6,
            "price": 40
          },
          {
            "name": "Feijão 1Kg",
            "amount": 5,
            "price": 15
          },
          {
            "name": "Abóbora",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Mel (300ml)",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Suco de uva 1L",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 4,
            "price": 10
          },
          {
            "name": "Doce de Leite",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Pão branco",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 9,
            "price": 35
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Mandioca sem casca",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 6,
            "price": 30
          },
          {
            "name": "Pepino (em natura)",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Flocão de Milho",
            "amount": 8,
            "price": 8
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 2,
            "price": 14
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Hortelã pimenta",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Tomate",
            "amount": 3,
            "price": 25
          },
          {
            "name": "Pão de mandioca",
            "amount": 8,
            "price": 12
          },
          {
            "name": "Bucha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Boné MST",
            "amount": 2,
            "price": 35
          },
          {
            "name": "Broa de Milho",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Queijo Fresco G",
            "amount": 1,
            "price": 32
          },
          {
            "name": "Molho de Pimenta",
            "amount": 3,
            "price": 10
          },
          {
            "name": "Açúcar mascavo",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Cachaça carvalho",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Cachaça prata",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Suco de manga",
            "amount": 3,
            "price": 17
          }
        ],
        "totalAmountExtraProductsSales": 2453
      },
      {
        "deliveryId": "q8CwCiehlORwksdH5gIu",
        "date": "2022-10-06",
        "dateText": "05/10/2022",
        "cestas": 32,
        "totalAmountBaseProductsSale": 1440,
        "extraProducts": [
          {
            "name": "Açafrão",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Suco de uva 1L",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Bolo de laranja",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Cenoura",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Jiló",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Pão integral",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 7,
            "price": 20
          },
          {
            "name": "Tomatinho",
            "amount": 13,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Pão branco",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Queijo Fresco P",
            "amount": 9,
            "price": 18
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Cachaça carvalho",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Beterraba",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Bolo de goiaba ",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Bone LGBT",
            "amount": 2,
            "price": 70
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 5,
            "price": 30
          },
          {
            "name": "Coentro",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Doce de Leite",
            "amount": 4,
            "price": 13
          },
          {
            "name": "Pimentão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de milho",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Flocão de Milho",
            "amount": 4,
            "price": 8
          },
          {
            "name": "Alface",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Geleia de uva",
            "amount": 2,
            "price": 14
          },
          {
            "name": "Pimenta do reino moída",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cachaça prata",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Pepino (em natura)",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Cachaça amburana",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Boné MST",
            "amount": 2,
            "price": 35
          },
          {
            "name": "Rosquinha recheada de goiabada",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Hortelã",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Ora-pro-nobis",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          }
        ],
        "totalAmountExtraProductsSales": 2008
      },
      {
        "deliveryId": "z6gErXbxRLUKDsUuXEKW",
        "date": "2022-10-20",
        "dateText": "19/10/2022",
        "cestas": 48,
        "totalAmountBaseProductsSale": 2160,
        "extraProducts": [
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Flocão de Milho",
            "amount": 2,
            "price": 8
          },
          {
            "name": "Pão integral",
            "amount": 9,
            "price": 12
          },
          {
            "name": "Queijo Fresco P",
            "amount": 6,
            "price": 18
          },
          {
            "name": "Tomatinho",
            "amount": 29,
            "price": 6
          },
          {
            "name": "Cachaça amburana",
            "amount": 5,
            "price": 45
          },
          {
            "name": "Pão de mandioca",
            "amount": 8,
            "price": 12
          },
          {
            "name": "Boné MST",
            "amount": 2,
            "price": 35
          },
          {
            "name": "Chuchu",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Doce de Leite",
            "amount": 3,
            "price": 13
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 9,
            "price": 35
          },
          {
            "name": "Jiló",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Nózinho de Coco",
            "amount": 3,
            "price": 10
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 6,
            "price": 15
          },
          {
            "name": "Coentro",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 6,
            "price": 7
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 3,
            "price": 14
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Pimentão",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Camiseta MST",
            "amount": 3,
            "price": 50
          },
          {
            "name": "Feijão 1Kg",
            "amount": 5,
            "price": 15
          },
          {
            "name": "Molho de Pimenta",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Pão branco",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Suco de manga",
            "amount": 4,
            "price": 17
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 9,
            "price": 20
          },
          {
            "name": "Almeirão",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Bolo de milho",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 7,
            "price": 30
          },
          {
            "name": "Hortelã",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Beterraba",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Chicória",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Frango caipira",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Bolo de laranja",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Cachaça prata",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Rosquinha recheada de goiabada",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Suco de uva 1L",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Hortelã pimenta",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Fresco G",
            "amount": 2,
            "price": 32
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Rosca de Côco com recheio de goiabada",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 20
          }
        ],
        "totalAmountExtraProductsSales": 2945
      },
      {
        "deliveryId": "xMwZDDdigDEvrA6bazPu",
        "date": "2022-11-03",
        "dateText": "02/11/2022",
        "cestas": 36,
        "totalAmountBaseProductsSale": 1620,
        "extraProducts": [
          {
            "name": "Jiló",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Molho de Tomate",
            "amount": 3,
            "price": 25
          },
          {
            "name": "Pão branco",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Tomatinho",
            "amount": 16,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Alho-poró",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Couve",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Pão integral",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 7,
            "price": 20
          },
          {
            "name": "Maxixe",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Nózinho de Coco",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Flocão de Milho",
            "amount": 1,
            "price": 8
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Feijão 1Kg",
            "amount": 6,
            "price": 15
          },
          {
            "name": "Rúcula",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Vagem",
            "amount": 9,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Chicória",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Bone LGBT",
            "amount": 2,
            "price": 70
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Bolo de milho",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Cachaça amburana",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Salsinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Suco de uva 1L",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Rosca de Côco com recheio de goiabada",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Rosquinha recheada de goiabada",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Cachaça prata",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Açúcar mascavo",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Cachaça carvalho",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Coentro",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          }
        ],
        "totalAmountExtraProductsSales": 1711
      },
      {
        "deliveryId": "BtjaVVUHYO4P8a8lDPe3",
        "date": "2022-11-17",
        "dateText": "16/11/2022",
        "cestas": 36,
        "totalAmountBaseProductsSale": 1620,
        "extraProducts": [
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 7,
            "price": 35
          },
          {
            "name": "Tomatinho",
            "amount": 23,
            "price": 6
          },
          {
            "name": "Abobrinha",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Maxixe",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Pão integral",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Queijo Fresco P",
            "amount": 3,
            "price": 18
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 6,
            "price": 20
          },
          {
            "name": "Bolo de milho",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Cachaça amburana",
            "amount": 3,
            "price": 45
          },
          {
            "name": "Cachaça carvalho",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 6,
            "price": 30
          },
          {
            "name": "Queijo Fresco G",
            "amount": 3,
            "price": 32
          },
          {
            "name": "Nózinho de Coco",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Pepino (em natura)",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Bolo de cenoura",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Acerola",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 7,
            "price": 8
          },
          {
            "name": "Melissa",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Cachaça prata",
            "amount": 3,
            "price": 45
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Pão branco",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Couve",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Açúcar mascavo ",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Chicória",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Beterraba",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Vagem",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Suco de uva 1L",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Geleia de amora",
            "amount": 4,
            "price": 14
          },
          {
            "name": "Chuchu",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Jiló",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Berinjela",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolacha de aveia",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Ora-pro-nobis",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pimenta do reino moída",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Salsinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Bolo de goiaba ",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Bolo de laranja",
            "amount": 1,
            "price": 20
          }
        ],
        "totalAmountExtraProductsSales": 2452
      },
      {
        "deliveryId": "EV4seVqZ5i8tp1K0v8El",
        "date": "2022-12-08",
        "dateText": "07/12/2022",
        "cestas": 38,
        "totalAmountBaseProductsSale": 1710,
        "extraProducts": [
          {
            "name": "Abóbora",
            "amount": 9,
            "price": 6
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Flocão de Milho",
            "amount": 4,
            "price": 8
          },
          {
            "name": "Pimentão",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Pão integral",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Alface",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Banana",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Berinjela",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Feijão 1Kg",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Manga",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Tomatinho",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Vagem",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Rabanete",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Acerola",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Doce de Leite",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Pepino (em natura)",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 3,
            "price": 14
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Pimenta do reino moída",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Geleia de amora",
            "amount": 2,
            "price": 14
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 11,
            "price": 20
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Maxixe",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Açúcar mascavo",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Pão branco",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Bolo de goiaba ",
            "amount": 1,
            "price": 20
          }
        ],
        "totalAmountExtraProductsSales": 1478
      },
      {
        "deliveryId": "pqAMgy7fCEOhkTdfACtk",
        "date": "2022-12-22",
        "dateText": "21/12/2022",
        "cestas": 29,
        "totalAmountBaseProductsSale": 1305,
        "extraProducts": [
          {
            "name": "Abóbora",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 4,
            "price": 40
          },
          {
            "name": "Contribuição de Natal 🎄",
            "amount": 96,
            "price": 10
          },
          {
            "name": "Quiabo",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 5,
            "price": 18
          },
          {
            "name": "Tomatinho",
            "amount": 14,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 6,
            "price": 35
          },
          {
            "name": "Limão ",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Beterraba",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Doce de Leite",
            "amount": 3,
            "price": 13
          },
          {
            "name": "Pepino (em natura)",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Mandioca sem casca",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Milho",
            "amount": 10,
            "price": 7.5
          },
          {
            "name": "Suco de uva 1L",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Banana",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Berinjela",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Bolo de cenoura",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Cheiro Verde",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Chicória",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Espinafre",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 8,
            "price": 20
          },
          {
            "name": "Pão integral",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Alho-poró",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Geleia de amora",
            "amount": 3,
            "price": 14
          },
          {
            "name": "Salsinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Acerola",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cachaça amburana",
            "amount": 4,
            "price": 45
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Feijão 1Kg",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Bolo de milho",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Queijo Fresco G",
            "amount": 1,
            "price": 32
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Jiló",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Açúcar mascavo",
            "amount": 1,
            "price": 13
          }
        ],
        "totalAmountExtraProductsSales": 2845
      },
      {
        "deliveryId": "1eUOz2yuJrEWQVe52J8w",
        "date": "2023-01-12",
        "dateText": "11/01/2023",
        "cestas": 26,
        "totalAmountBaseProductsSale": 1170,
        "extraProducts": [
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Feijão 1Kg",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Doce de Leite",
            "amount": 3,
            "price": 13
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Pão integral",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Abacaxi",
            "amount": 12,
            "price": 6
          },
          {
            "name": "Abiu",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Cenoura",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Salsinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Quiabo",
            "amount": 9,
            "price": 6
          },
          {
            "name": "Vagem",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 2,
            "price": 8
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 8,
            "price": 20
          },
          {
            "name": "Hortelã",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Colorau (100g)",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Açúcar mascavo",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Cebolinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Taioba",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cachaça amburana",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Pimenta biquinho",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Molho de Pimenta",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Erva-cidreira",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro pimenta",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Geleia de manga com pimenta ",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 1,
            "price": 12
          }
        ],
        "totalAmountExtraProductsSales": 1057
      },
      {
        "deliveryId": "HCYBjgcfk9rXjim2EOmK",
        "date": "2023-01-26",
        "dateText": "25/01/2023",
        "cestas": 27,
        "totalAmountBaseProductsSale": 1215,
        "extraProducts": [
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Molho de Tomate",
            "amount": 4,
            "price": 25
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Abacaxi",
            "amount": 11,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 6,
            "price": 18
          },
          {
            "name": "Geleia de goiaba",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Manga",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Cachaça amburana",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Pimenta em conserva",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Abóbora",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Queijo Fresco G",
            "amount": 1,
            "price": 32
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 5,
            "price": 12
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Flocão de Milho",
            "amount": 2,
            "price": 8
          },
          {
            "name": "Vagem",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 5,
            "price": 12
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 8,
            "price": 20
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 3,
            "price": 35
          },
          {
            "name": "Cachaça prata",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Geleia de manga com pimenta ",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Abóbora moranga inteira (6 reais por kg)",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Pão integral",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Geleia de amora",
            "amount": 2,
            "price": 14
          },
          {
            "name": "Feijão 1Kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Doce de manga grande",
            "amount": 1,
            "price": 25
          }
        ],
        "totalAmountExtraProductsSales": 1466
      },
      {
        "deliveryId": "Zk1nkuGv5Vsa9zZgyjBq",
        "date": "2023-02-02",
        "dateText": "01/02/2023",
        "cestas": 27,
        "totalAmountBaseProductsSale": 1215,
        "extraProducts": [
          {
            "name": "Hortelã",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Vagem",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Cachaça prata",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Pão integral",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Feijão 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pão branco",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 3,
            "price": 35
          },
          {
            "name": "Flocão de Milho",
            "amount": 2,
            "price": 8
          },
          {
            "name": "Queijo Fresco P",
            "amount": 2,
            "price": 18
          },
          {
            "name": "Hortelã pimenta",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Geleia de uva",
            "amount": 2,
            "price": 14
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Queijo Fresco G",
            "amount": 1,
            "price": 32
          },
          {
            "name": "Colorau 150g",
            "amount": 1,
            "price": 10
          }
        ],
        "totalAmountExtraProductsSales": 719
      },
      {
        "deliveryId": "UrAPa6XCWUsS1wv2WJsb",
        "date": "2023-02-16",
        "dateText": "15/02/2023",
        "cestas": 27,
        "totalAmountBaseProductsSale": 1215,
        "extraProducts": [
          {
            "name": "Abobrinha",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Cebolinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 12,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Pão integral",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Salsinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 4,
            "price": 17
          },
          {
            "name": "Alho-poró",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Bolo de cenoura",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Açúcar mascavo",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Banana",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Doce de Leite",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Feijão 1Kg",
            "amount": 6,
            "price": 15
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 8,
            "price": 20
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Milho",
            "amount": 1,
            "price": 7.5
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Flocão de Milho",
            "amount": 2,
            "price": 8
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Molho de Pimenta",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Quiabo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de goiaba ",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Suco de uva 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 1,
            "price": 12
          }
        ],
        "totalAmountExtraProductsSales": 1011.5
      },
      {
        "deliveryId": "KQseS1LbIQ1CRBUwVvuG",
        "date": "2023-03-02",
        "dateText": "01/03/2023",
        "cestas": 31,
        "totalAmountBaseProductsSale": 1395,
        "extraProducts": [
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 14,
            "price": 20
          },
          {
            "name": "Abobrinha",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Mamão",
            "amount": 9,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 6,
            "price": 18
          },
          {
            "name": "Alho-poró",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 4,
            "price": 17
          },
          {
            "name": "Manjericão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Colorau 150g",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Pão de mandioca",
            "amount": 5,
            "price": 12
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 6,
            "price": 35
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Melissa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Cachaça Socialista",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Limão ",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Açúcar mascavo",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Flocão de Milho",
            "amount": 4,
            "price": 8
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Feijão 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Doce de Leite",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Rosquinha recheada de goiabada",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Pão integral",
            "amount": 1,
            "price": 12
          }
        ],
        "totalAmountExtraProductsSales": 1494
      },
      {
        "deliveryId": "FuudaAYkQ2gdVVJMPE6J",
        "date": "2023-03-16",
        "dateText": "15/03/2023",
        "cestas": 27,
        "totalAmountBaseProductsSale": 1215,
        "extraProducts": [
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Pão de mandioca",
            "amount": 5,
            "price": 12
          },
          {
            "name": "Queijo Fresco P",
            "amount": 9,
            "price": 18
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 11,
            "price": 20
          },
          {
            "name": "Tomatinho",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Banana",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Cebolinha",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Mamão Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Salsinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Doce de manga",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Cachaça carvalho",
            "amount": 3,
            "price": 45
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Pão integral",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Couve",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Bolo de laranja",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Geleia de manga com pimenta ",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Feijão 1Kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Cachaça prata",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 1,
            "price": 35
          },
          {
            "name": "Abobrinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1337
      },
      {
        "deliveryId": "jIZJnQXCPUKzfWFk1cgK",
        "date": "2023-03-30",
        "dateText": "29/03/2023",
        "cestas": 23,
        "totalAmountBaseProductsSale": 1035,
        "extraProducts": [
          {
            "name": "Feijão 1Kg",
            "amount": 7,
            "price": 15
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 10,
            "price": 20
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Geleia de mamão com cajá manga",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Pimenta do reino moída",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Colorau 150g",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Queijo Fresco P",
            "amount": 6,
            "price": 18
          },
          {
            "name": "Pão de mandioca",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Pão integral",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Bolo de cenoura",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Abacate",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 1,
            "price": 35
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Molho de Pimenta",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 3,
            "price": 17
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Açúcar mascavo",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Geleia de manga com pimenta ",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1158
      },
      {
        "deliveryId": "d9Tj3uOqObW1S2edDbS3",
        "date": "2023-04-06",
        "dateText": "05/04/2023",
        "cestas": 19,
        "totalAmountBaseProductsSale": 855,
        "extraProducts": [
          {
            "name": "Queijo Meia Cura G",
            "amount": 3,
            "price": 35
          },
          {
            "name": "Geleia de mamão com cajá manga",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Pão de mandioca",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Queijo Fresco P",
            "amount": 3,
            "price": 18
          },
          {
            "name": "Banana",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Salsinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 4,
            "price": 20
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mamão Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Cachaça prata",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Pimenta comari",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Queijo Fresco G",
            "amount": 1,
            "price": 32
          },
          {
            "name": "Bolo de milho",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          }
        ],
        "totalAmountExtraProductsSales": 666
      },
      {
        "deliveryId": "5BCwbNUkgiMkxoqLfb67",
        "date": "2023-04-20",
        "dateText": "19/04/2023",
        "cestas": 20,
        "totalAmountBaseProductsSale": 900,
        "extraProducts": [
          {
            "name": "Manjericão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Cachaça carvalho",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Bolo de cenoura",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Pão integral",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Banana",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Rúcula",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Bolo de laranja",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Geleia de mamão com cajá manga",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Mamão Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 5,
            "price": 12
          },
          {
            "name": "Rabanete",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Pão branco",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Cachaça prata",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Melissa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          }
        ],
        "totalAmountExtraProductsSales": 878
      },
      {
        "deliveryId": "B9eYpSxKceKklzDsnnXZ",
        "date": "2023-05-04",
        "dateText": "03/05/2023",
        "cestas": 24,
        "totalAmountBaseProductsSale": 1080,
        "extraProducts": [
          {
            "name": "Queijo Fresco P",
            "amount": 8,
            "price": 18
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 35
          },
          {
            "name": "Rúcula",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Beterraba",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Pepino (em natura)",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Cachaça carvalho",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Chuchu",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Coentro",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Doce de Leite",
            "amount": 3,
            "price": 13
          },
          {
            "name": "Pão de mandioca",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 9,
            "price": 20
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Feijão 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Melissa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Açúcar mascavo",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 997
      },
      {
        "deliveryId": "VE8uhRMp7H11FgrA2635",
        "date": "2023-05-18",
        "dateText": "17/05/2023",
        "cestas": 19,
        "totalAmountBaseProductsSale": 855,
        "extraProducts": [
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 6,
            "price": 30
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 3,
            "price": 17
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Feijão 1Kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Açúcar mascavo",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Berinjela",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Bolo de cenoura",
            "amount": 4,
            "price": 20
          },
          {
            "name": "Chuchu",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Coentro",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Sucos 1 litro",
            "amount": 9,
            "price": 17
          },
          {
            "name": "Boné Simples ",
            "amount": 3,
            "price": 25
          },
          {
            "name": "Doce de Leite",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Geleia de mamão com cajá manga",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Conserva Pimenta Dedo de Moça",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Mandioca sem casca",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Geleia de goiaba",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Rúcula",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Pão integral",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Pão branco",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Cachaça prata",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Conserva pimenta cumari 170g",
            "amount": 1,
            "price": 15
          }
        ],
        "totalAmountExtraProductsSales": 1154
      },
      {
        "deliveryId": "qslpSKNu85ygeJT97K9P",
        "date": "2023-06-01",
        "dateText": "31/05/2023",
        "cestas": 16,
        "totalAmountBaseProductsSale": 720,
        "extraProducts": [
          {
            "name": "Cachaça prata",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Quiabo",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 5,
            "price": 30
          },
          {
            "name": "Geleia de manga",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Colorau 150g",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 5,
            "price": 35
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Cenoura",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 6,
            "price": 18
          },
          {
            "name": "Rabanete",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Rúcula",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Pão integral",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 4,
            "price": 20
          },
          {
            "name": "Feijão 1Kg",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Pão de mandioca",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Bolo de cenoura",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Doce de Leite",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Geleia de goiaba",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Flocão de Milho",
            "amount": 1,
            "price": 8
          },
          {
            "name": "Rosquinha recheada de goiabada",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Salsinha",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1300
      },
      {
        "deliveryId": "7mw5hMIbte17FaaqIU2u",
        "date": "2023-06-22",
        "dateText": "21/06/2023",
        "cestas": 25,
        "totalAmountBaseProductsSale": 1125,
        "extraProducts": [
          {
            "name": "Bolo de milho",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Cenoura",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 1,
            "price": 35
          },
          {
            "name": "Molho de Pimenta",
            "amount": 3,
            "price": 10
          },
          {
            "name": "Salsinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Pão integral",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Feijão 1Kg",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Beterraba",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Cachaça carvalho",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Geleia de cajamanga",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 2,
            "price": 15
          }
        ],
        "totalAmountExtraProductsSales": 624
      },
      {
        "deliveryId": "OjFFaLXaYDvS6ha84upm",
        "date": "2023-07-06",
        "dateText": "05/07/2023",
        "cestas": 22,
        "totalAmountBaseProductsSale": 990,
        "extraProducts": [
          {
            "name": "Geleia de manga com cajamanga",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Cheiro Verde",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Hortelã pimenta",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Manjericão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Cenoura",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Farinha de mandioca artesanal do Lió",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 5,
            "price": 15
          },
          {
            "name": "Babosa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pão integral",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Queijo Fresco P",
            "amount": 5,
            "price": 18
          },
          {
            "name": "Coentro",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Beterraba",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Rúcula",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 35
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 4,
            "price": 20
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Batata Doce",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Berinjela",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Farinha de mandioca puba",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Chuchu",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Feijão 1Kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Bolo de laranja",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Molho de Pimenta",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Salsinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de cenoura",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Pão de mandioca",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Conserva Pimenta Dedo de Moça",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 1,
            "price": 12
          }
        ],
        "totalAmountExtraProductsSales": 1009
      },
      {
        "deliveryId": "iWOFaW08o8sCRGv93W81",
        "date": "2023-07-20",
        "dateText": "19/07/2023",
        "cestas": 14,
        "totalAmountBaseProductsSale": 630,
        "extraProducts": [
          {
            "name": "Pão de mandioca",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Molho de pimenta grande",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Brócolis ",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 5,
            "price": 15
          },
          {
            "name": "Molho de Pimenta",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Coentro",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Geleia de manga com cajamanga",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Pão integral",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Abacate",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Pão de beterraba",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Farinha de mandioca artesanal do Lió",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Farinha de mandioca puba",
            "amount": 1,
            "price": 15
          }
        ],
        "totalAmountExtraProductsSales": 651
      },
      {
        "deliveryId": "0C2RldDzadEKb5nxPVCG",
        "date": "2023-08-03",
        "dateText": "02/08/2023",
        "cestas": 21,
        "totalAmountBaseProductsSale": 945,
        "extraProducts": [
          {
            "name": "Espinafre",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Rúcula",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Banana",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Queijo Fresco P",
            "amount": 6,
            "price": 18
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 3,
            "price": 8
          },
          {
            "name": "Pão de beterraba",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 3,
            "price": 35
          },
          {
            "name": "Tomatinho",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 6,
            "price": 15
          },
          {
            "name": "Abacate",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Feijão 1Kg",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Feijão guandu 500g",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Geleia de goiaba",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Geleia de manga",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Tempero caseiro pimenta",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cenoura",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Rosca de Côco com recheio de goiabada",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          }
        ],
        "totalAmountExtraProductsSales": 1048
      },
      {
        "deliveryId": "dspcPg2dPs5qs3hQptMa",
        "date": "2023-08-17",
        "dateText": "16/08/2023",
        "cestas": 15,
        "totalAmountBaseProductsSale": 675,
        "extraProducts": [
          {
            "name": "Queijo Meia Cura G",
            "amount": 6,
            "price": 35
          },
          {
            "name": "Alface",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Tomatinho",
            "amount": 10,
            "price": 6
          },
          {
            "name": "Babosa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Geleia de pimenta ",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Queijo Fresco P",
            "amount": 5,
            "price": 18
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 6,
            "price": 20
          },
          {
            "name": "Pão de mandioca",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 8,
            "price": 15
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Pão de beterraba",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Farinha de mandioca artesanal do Lió",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Geleia abóbora com manga",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Flocão de Milho",
            "amount": 2,
            "price": 8
          },
          {
            "name": "Conserva pimenta cumari 170g",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Geleia de goiaba",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Farinha de mandioca puba",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Coentro",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Feijão 1Kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Salsinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Espinafre",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1228
      },
      {
        "deliveryId": "Aq5jvjuKfFM608VJK1SD",
        "date": "2023-08-31",
        "dateText": "30/08/2023",
        "cestas": 11,
        "totalAmountBaseProductsSale": 495,
        "extraProducts": [
          {
            "name": "Alho-poró",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Beterraba",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 7,
            "price": 15
          },
          {
            "name": "Tomatinho",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 5,
            "price": 12
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Feijão 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 5,
            "price": 35
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Alface",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 6,
            "price": 18
          },
          {
            "name": "Pimentão",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 3,
            "price": 8
          },
          {
            "name": "Banana",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 4,
            "price": 20
          },
          {
            "name": "Inhame",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Coentro",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 7,
            "price": 30
          },
          {
            "name": "Abobrinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Berinjela",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Chicória",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Espinafre",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Farinha de mandioca puba",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Boné MST",
            "amount": 1,
            "price": 35
          },
          {
            "name": "Pão de beterraba",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Geleia de goiaba",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Doce de Leite",
            "amount": 3,
            "price": 13
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Couve",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Farinha de mandioca (normal) 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Repolho ",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1695
      },
      {
        "deliveryId": "gm425PCxPbAjnJis4dEo",
        "date": "2023-09-14",
        "dateText": "13/09/2023",
        "cestas": 16,
        "totalAmountBaseProductsSale": 720,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 5,
            "price": 30
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 4,
            "price": 35
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 11,
            "price": 15
          },
          {
            "name": "Pimentão",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Molho de pimenta grande",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Tomatinho",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Salsinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Coentro",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Cachaça carvalho",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Espinafre",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Farinha de mandioca artesanal do Lió",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Alface",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Queijo Fresco P",
            "amount": 2,
            "price": 18
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Açafrão ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alecrim",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Cenoura",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 5,
            "price": 20
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Pepino (em natura)",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1075
      },
      {
        "deliveryId": "4c0K0dOy1yKPwlX9GpqS",
        "date": "2023-10-05",
        "dateText": "04/10/2023",
        "cestas": 9,
        "totalAmountBaseProductsSale": 405,
        "extraProducts": [
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Doce de banana",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Tomatinho",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Molho de pimenta grande",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 8,
            "price": 15
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Espinafre",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Nózinho de Coco",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Queijo Fresco P",
            "amount": 5,
            "price": 18
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 4,
            "price": 35
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 1,
            "price": 30
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Pão de mandioca",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Bolo de milho",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Farinha de mandioca (normal) 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Pão branco",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Doce de Leite",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Alface",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Babosa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Banana",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Doce de manga",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Cachaça prata",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Pimentão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Salsinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Farinha de mandioca puba",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Flocão de Milho",
            "amount": 1,
            "price": 8
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 30
          }
        ],
        "totalAmountExtraProductsSales": 1169
      },
      {
        "deliveryId": "9KmqpZtVyL6ZyPCJgXSQ",
        "date": "2023-10-19",
        "dateText": "18/10/2023",
        "cestas": 12,
        "totalAmountBaseProductsSale": 540,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 5,
            "price": 30
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Feijão 1Kg",
            "amount": 5,
            "price": 15
          },
          {
            "name": "Flocão de Milho",
            "amount": 2,
            "price": 8
          },
          {
            "name": "Pão de beterraba",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 5,
            "price": 35
          },
          {
            "name": "Rosca de Côco com recheio de goiabada",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Alface",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Pão branco",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Tomatinho",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Espinafre",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Queijo Fresco P",
            "amount": 3,
            "price": 18
          },
          {
            "name": "Geleia de frutas picantes",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Cebola 500g",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Pimentão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Banana",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 6,
            "price": 15
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1043
      },
      {
        "deliveryId": "W1h2dMgDolhi88i4mBIe",
        "date": "2023-11-02",
        "dateText": "01/11/2023",
        "cestas": 19,
        "totalAmountBaseProductsSale": 855,
        "extraProducts": [
          {
            "name": "Almeirão",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Babosa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Berinjela",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Melissa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de pimenta grande",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 7,
            "price": 15
          },
          {
            "name": "Pimentão",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Tomatinho",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 2,
            "price": 8
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Queijo Fresco P",
            "amount": 3,
            "price": 18
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Coentro",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 1,
            "price": 35
          },
          {
            "name": "Pepino (em natura)",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Geleia de manga com pimenta ",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pipoca 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          }
        ],
        "totalAmountExtraProductsSales": 718
      },
      {
        "deliveryId": "w8lu23eYYJF9JEh567t6",
        "date": "2023-11-16",
        "dateText": "15/11/2023",
        "cestas": 8,
        "totalAmountBaseProductsSale": 360,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 10,
            "price": 30
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Feijão 1Kg",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Flocão de Milho",
            "amount": 2,
            "price": 8
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 11,
            "price": 15
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Quiabo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cebolinha",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Cheiro Verde",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Alecrim",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Manjericão",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Tomatinho",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro salsinha",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Doce de Leite",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          }
        ],
        "totalAmountExtraProductsSales": 1190
      },
      {
        "deliveryId": "91OZov8wVXokeJEOOgQW",
        "date": "2023-12-07",
        "dateText": "06/12/2023",
        "cestas": 13,
        "totalAmountBaseProductsSale": 585,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Beterraba",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 3,
            "price": 35
          },
          {
            "name": "Milho",
            "amount": 6,
            "price": 7.5
          },
          {
            "name": "Alface",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Feijão 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 9,
            "price": 15
          },
          {
            "name": "Queijo Fresco P",
            "amount": 3,
            "price": 18
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Espinafre",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Molho de Tomate",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Babosa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Molho de pimenta grande",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Geleia dr abacaxi com pimenta",
            "amount": 1,
            "price": 15
          }
        ],
        "totalAmountExtraProductsSales": 924
      },
      {
        "deliveryId": "05nTjVVNpLh5Vnq20BVg",
        "date": "2023-12-21",
        "dateText": "20/12/2023",
        "cestas": 14,
        "totalAmountBaseProductsSale": 630,
        "extraProducts": [
          {
            "name": "Contribuição de Natal 🎄",
            "amount": 60,
            "price": 10
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 8,
            "price": 15
          },
          {
            "name": "Limão ",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Milho",
            "amount": 8,
            "price": 15
          },
          {
            "name": "Quiabo",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Abacaxi",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 3,
            "price": 17
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 6,
            "price": 20
          },
          {
            "name": "Maracujá",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Frango caipira",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Queijo Fresco P",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Nózinho de Coco",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 35
          },
          {
            "name": "Cachaça amburana",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Banana",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de laranja",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 1,
            "price": 8
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 4,
            "price": 12
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1891
      },
      {
        "deliveryId": "ALevGk16NWCzBbtxvquN",
        "date": "2024-01-18",
        "dateText": "17/01/2024",
        "cestas": 12,
        "totalAmountBaseProductsSale": 540,
        "extraProducts": [
          {
            "name": "Café Cecília (moído)",
            "amount": 5,
            "price": 30
          },
          {
            "name": "Doce de Leite",
            "amount": 2,
            "price": 13
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 11,
            "price": 15
          },
          {
            "name": "Pão de mandioca",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Manjericão",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Pão integral",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 4,
            "price": 35
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 10,
            "price": 30
          },
          {
            "name": "Cheiro Verde",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Frango caipira",
            "amount": 2,
            "price": 50
          },
          {
            "name": "Limão ",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 3,
            "price": 18
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Farinha de mandioca artesanal do Lió",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 2,
            "price": 8
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Coentro",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Jiló",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Berinjela",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 3,
            "price": 17
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Conserva pimenta cumari 170g",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          }
        ],
        "totalAmountExtraProductsSales": 1397
      },
      {
        "deliveryId": "dJEGQEJnYCmpwIHF5Hgb",
        "date": "2024-02-01",
        "dateText": "31/01/2024",
        "cestas": 16,
        "totalAmountBaseProductsSale": 720,
        "extraProducts": [
          {
            "name": "Queijo Fresco P",
            "amount": 5,
            "price": 18
          },
          {
            "name": "Quiabo",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Banana",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 4,
            "price": 35
          },
          {
            "name": "Bolo de cenoura",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Bolo de milho",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 6,
            "price": 15
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Arroz 1kg (Branco / Integral)",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Feijão 1Kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Jiló",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Geleia de goiaba",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Cheiro Verde",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Berinjela",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 3,
            "price": 8
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Mamão Verde",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Maracujá",
            "amount": 2,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1162
      },
      {
        "deliveryId": "7fTd3tN25vwSvVd0Fm46",
        "date": "2024-02-08",
        "dateText": "07/02/2024",
        "cestas": 9,
        "totalAmountBaseProductsSale": 405,
        "extraProducts": [
          {
            "name": "Queijo Fresco P",
            "amount": 3,
            "price": 18
          },
          {
            "name": "Tempero caseiro pimenta",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Bolo de laranja",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Mamão Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Rabanete",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Abacate",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Banana",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 3,
            "price": 35
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 3,
            "price": 15
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 5,
            "price": 30
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Bolo de milho",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Rúcula",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          }
        ],
        "totalAmountExtraProductsSales": 746
      },
      {
        "deliveryId": "W2O3XaTUVIpKa0N2P04y",
        "date": "2024-02-22",
        "dateText": "21/02/2024",
        "cestas": 11,
        "totalAmountBaseProductsSale": 495,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 13,
            "price": 30
          },
          {
            "name": "Feijão 1Kg",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Flocão de Milho",
            "amount": 5,
            "price": 8
          },
          {
            "name": "Quiabo",
            "amount": 9,
            "price": 6
          },
          {
            "name": "Berinjela",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Tomatinho",
            "amount": 9,
            "price": 6
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 5,
            "price": 15
          },
          {
            "name": "Molho de pimenta grande",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Abacate",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Mamão Verde",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Bolo de milho",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Pão de beterraba",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Frango caipira",
            "amount": 1,
            "price": 50
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 13
          },
          {
            "name": "Pão integral",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Jiló",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1116
      },
      {
        "deliveryId": "kgvUOD2kuwB77ROW6joE",
        "date": "2024-03-07",
        "dateText": "06/03/2024",
        "cestas": 22,
        "totalAmountBaseProductsSale": 990,
        "extraProducts": [
          {
            "name": "Cebolinha",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Banana",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Chicória",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Hortelã pimenta",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Queijo Fresco P",
            "amount": 2,
            "price": 18
          },
          {
            "name": "Mamão",
            "amount": 4,
            "price": 10
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 30
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 8,
            "price": 35
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Abacate",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Farinha de mandioca (normal) 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Flocão de Milho",
            "amount": 7,
            "price": 8
          },
          {
            "name": "Feijão 1Kg",
            "amount": 5,
            "price": 15
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Tomatinho",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Geleia de abacaxi com pimenta",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Jiló",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Berinjela",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Farinha de mandioca Lió pequeno",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mamão Verde",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Farinha de mandioca artesanal do Lió",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Bolo de laranja",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Geleia de goiaba",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 4,
            "price": 17
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 1,
            "price": 12
          }
        ],
        "totalAmountExtraProductsSales": 1213
      },
      {
        "deliveryId": "2sWVQn6fyt30GaSkIKMy",
        "date": "2024-03-21",
        "dateText": "20/03/2024",
        "cestas": 14,
        "totalAmountBaseProductsSale": 630,
        "extraProducts": [
          {
            "name": "Abacate",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Mamão Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 35
          },
          {
            "name": "Quiabo",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 3,
            "price": 18
          },
          {
            "name": "Taioba",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Maxixe",
            "amount": 1,
            "price": 6
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 5,
            "price": 30
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Farinha de mandioca Lió 500g",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cebolinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Tomatinho",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Jiló",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Espinafre",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 669
      },
      {
        "deliveryId": "FAu30bW8MHr74ecoWBUG",
        "date": "2024-04-04",
        "dateText": "03/04/2024",
        "cestas": 12,
        "totalAmountBaseProductsSale": 540,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 7,
            "price": 15
          },
          {
            "name": "Farinha de mandioca puba",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Maracujá",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Cebolinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Mamão",
            "amount": 4,
            "price": 10
          },
          {
            "name": "Quiabo",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Berinjela",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Molho de pimenta grande",
            "amount": 3,
            "price": 12
          },
          {
            "name": "Chicória",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Abacate",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Geleia de abacaxi com pimenta",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Farinha de mandioca (normal) 1kg",
            "amount": 1,
            "price": 12
          }
        ],
        "totalAmountExtraProductsSales": 466
      },
      {
        "deliveryId": "3P1xHlSCNEkgF4960WMQ",
        "date": "2024-04-18",
        "dateText": "17/04/2024",
        "cestas": 6,
        "totalAmountBaseProductsSale": 270,
        "extraProducts": [
          {
            "name": "Queijo Meia Cura G",
            "amount": 5,
            "price": 35
          },
          {
            "name": "Maracujá",
            "amount": 1,
            "price": 6
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 9,
            "price": 30
          },
          {
            "name": "Abacate",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 6,
            "price": 12
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Queijo Fresco P",
            "amount": 3,
            "price": 18
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Taioba",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Banana",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Tempero caseiro pimenta",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Coentro",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 880
      },
      {
        "deliveryId": "0tK9cjNLlAjHuVyv5Ai0",
        "date": "2024-05-09",
        "dateText": "08/05/2024",
        "cestas": 10,
        "totalAmountBaseProductsSale": 450,
        "extraProducts": [
          {
            "name": "Queijo Meia Cura G",
            "amount": 5,
            "price": 35
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 20
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 30
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Mamão Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Melissa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 2,
            "price": 17
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 14
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Flocão de Milho",
            "amount": 7,
            "price": 9
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 3,
            "price": 19
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 4,
            "price": 18
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Quiabo",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 55
          },
          {
            "name": "Mamão",
            "amount": 3,
            "price": 10
          },
          {
            "name": "Abacate",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Café Terra de Sabores Tradicional",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Arroz Parborizado 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Conserva de pimenta (M)",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Babosa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Hortelã pimenta",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          }
        ],
        "totalAmountExtraProductsSales": 1142
      },
      {
        "deliveryId": "JwW8IS0IFV37fu6ACwhn",
        "date": "2024-05-23",
        "dateText": "22/05/2024",
        "cestas": 17,
        "totalAmountBaseProductsSale": 765,
        "extraProducts": [
          {
            "name": "Limão ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Açafrão ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 7,
            "price": 15
          },
          {
            "name": "Mamão",
            "amount": 6,
            "price": 10
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Rúcula",
            "amount": 6,
            "price": 6
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 12,
            "price": 30
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 4,
            "price": 22
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 3,
            "price": 55
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Queijo Fresco P",
            "amount": 4,
            "price": 18
          },
          {
            "name": "Conserva de pimenta (G)",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Abacate",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Banana 1 kg",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 3,
            "price": 19
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Mandioca sem casca",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Suco de manga",
            "amount": 3,
            "price": 19
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 35
          },
          {
            "name": "Tempero caseiro pimenta",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Flocão de Milho",
            "amount": 5,
            "price": 9
          },
          {
            "name": "Hortelã pimenta",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pimenta do reino moída",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Mamão Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Fresco G",
            "amount": 1,
            "price": 32
          }
        ],
        "totalAmountExtraProductsSales": 1521
      },
      {
        "deliveryId": "Uam1lnLy7hN26wv5ZuVs",
        "date": "2024-06-06",
        "dateText": "05/06/2024",
        "cestas": 18,
        "totalAmountBaseProductsSale": 810,
        "extraProducts": [
          {
            "name": "Limão ",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Feijão 1Kg",
            "amount": 5,
            "price": 15
          },
          {
            "name": "Mamão Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 6,
            "price": 15
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 19
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 4,
            "price": 22
          },
          {
            "name": "Beterraba",
            "amount": 4,
            "price": 6
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 7,
            "price": 30
          },
          {
            "name": "Cheiro Verde",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          }
        ],
        "totalAmountExtraProductsSales": 840
      },
      {
        "deliveryId": "anWpajxa10IxeWRCXB55",
        "date": "2024-06-20",
        "dateText": "19/06/2024",
        "cestas": 15,
        "totalAmountBaseProductsSale": 675,
        "extraProducts": [
          {
            "name": "Feijão 1Kg",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 4,
            "price": 22
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Queijo Fresco P",
            "amount": 5,
            "price": 18
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Molho de Tomate",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 4,
            "price": 35
          },
          {
            "name": "Cheiro Verde",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Beterraba",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Tomatinho",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 9,
            "price": 15
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Rabanete",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Quiabo",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 14
          },
          {
            "name": "Abacate",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Flocão de Milho",
            "amount": 2,
            "price": 9
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Hortelã pimenta",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Tempero caseiro pimenta",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Banana 1 kg",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cachaça prata",
            "amount": 1,
            "price": 45
          }
        ],
        "totalAmountExtraProductsSales": 1186
      },
      {
        "deliveryId": "1CeV4VY1YwbdNBF7Xga0",
        "date": "2024-07-04",
        "dateText": "03/07/2024",
        "cestas": 16,
        "totalAmountBaseProductsSale": 720,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 8,
            "price": 30
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Chicória",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 5,
            "price": 15
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Queijo Fresco P",
            "amount": 7,
            "price": 18
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 35
          },
          {
            "name": "Espinafre",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Beterraba",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Tomatinho",
            "amount": 8,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 1,
            "price": 9
          },
          {
            "name": "Pimenta do reino moída",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Banana 1 kg",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Hortelã pimenta",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Tomate",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Rabanete",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de mandioca",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Mamão Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Chuchu",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 19
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 19
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          }
        ],
        "totalAmountExtraProductsSales": 1161
      },
      {
        "deliveryId": "oIgAihVWqpf5A6u7J0u4",
        "date": "2024-07-18",
        "dateText": "17/07/2024",
        "cestas": 11,
        "totalAmountBaseProductsSale": 495,
        "extraProducts": [
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Cebolinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Cheiro Verde",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Hortelã pimenta",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 4,
            "price": 18
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 35
          },
          {
            "name": "Salsinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Batata Doce",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Tomate",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Tomatinho",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Banana 1 kg",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Espinafre",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 8,
            "price": 15
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 30
          },
          {
            "name": "Rabanete",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Chuchu",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 2,
            "price": 9
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Doce de Leite",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 19
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Feijão 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 14
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Conserva Pimenta Dedo de Moça 300 ml",
            "amount": 1,
            "price": 20
          }
        ],
        "totalAmountExtraProductsSales": 1091
      },
      {
        "deliveryId": "Rtp2YHs3qvSkEoOBncu4",
        "date": "2024-08-08",
        "dateText": "07/08/2024",
        "cestas": 16,
        "totalAmountBaseProductsSale": 720,
        "extraProducts": [
          {
            "name": "Ovos (dúzia)",
            "amount": 16,
            "price": 15
          },
          {
            "name": "Cachaça carvalho",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 55
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 5,
            "price": 30
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 4,
            "price": 35
          },
          {
            "name": "Cenoura",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 2,
            "price": 9
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Rabanete",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Tomatinho",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Molho de pimenta Pequeno 150ml",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Vagem",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Espinafre",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Batata Doce",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Rúcula",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Abobrinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de pimenta grande",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Feijão 1Kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Molho de Pimenta",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 19
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Coentro",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1184
      },
      {
        "deliveryId": "2R3zYLAVCNVOYmLEsCRC",
        "date": "2024-08-22",
        "dateText": "21/08/2024",
        "cestas": 21,
        "totalAmountBaseProductsSale": 945,
        "extraProducts": [
          {
            "name": "Cheiro Verde",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Rúcula",
            "amount": 1,
            "price": 6
          },
          {
            "name": "1/2 queijo meia cura",
            "amount": 7,
            "price": 18
          },
          {
            "name": "Banana 1 kg",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Espinafre",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Chuchu",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 3,
            "price": 55
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Repolho ",
            "amount": 7,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Geleia de frutas picantes",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Salsinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 4,
            "price": 18
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 5,
            "price": 30
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 11,
            "price": 15
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Arroz Parborizado 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Coentro",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Tomatinho",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mamão Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 1,
            "price": 35
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Melissa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Boné MST",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Alho-poró",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 1287
      },
      {
        "deliveryId": "U8HN76TbSN2LQnDKMYlY",
        "date": "2024-09-05",
        "dateText": "04/09/2024",
        "cestas": 14,
        "totalAmountBaseProductsSale": 630,
        "extraProducts": [
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Tomatinho",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 4,
            "price": 22
          },
          {
            "name": "Jabuticaba",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Chicória",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Vagem",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Beterraba",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Rúcula",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Cebola 500g",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 5,
            "price": 15
          },
          {
            "name": "Banana 1 kg",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Geleia de frutas picantes",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 1,
            "price": 35
          }
        ],
        "totalAmountExtraProductsSales": 772
      },
      {
        "deliveryId": "wFASEDB6KMhoL8oeDwTB",
        "date": "2024-09-19",
        "dateText": "18/09/2024",
        "cestas": 10,
        "totalAmountBaseProductsSale": 450,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 9,
            "price": 30
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Mandioca sem casca",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Salsinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Vagem",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Colorau 150g",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 10,
            "price": 15
          },
          {
            "name": "Queijo Fresco P",
            "amount": 4,
            "price": 22
          },
          {
            "name": "Rúcula",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 5,
            "price": 40
          },
          {
            "name": "Tempero caseiro pimenta",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 19
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 19
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Espinafre",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Banana 1 kg",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Beterraba",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cenoura",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Alho-poró",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Doce de Leite",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Tomatinho",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Bolo de laranja",
            "amount": 1,
            "price": 25
          }
        ],
        "totalAmountExtraProductsSales": 1163
      },
      {
        "deliveryId": "c8So0X5rvDpVZKpIrfdr",
        "date": "2024-10-03",
        "dateText": "02/10/2024",
        "cestas": 16,
        "totalAmountBaseProductsSale": 720,
        "extraProducts": [
          {
            "name": "1/2 queijo meia cura",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Tomatinho",
            "amount": 12,
            "price": 6
          },
          {
            "name": "Vagem",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Jabuticaba",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 17,
            "price": 15
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 14
          },
          {
            "name": "Feijão 1Kg",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Limão ",
            "amount": 6,
            "price": 6
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 7,
            "price": 30
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Hortelã",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 3,
            "price": 19
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 6,
            "price": 22
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 3,
            "price": 40
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 3,
            "price": 19
          },
          {
            "name": "Alface",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Cebolinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Abobrinha",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Coentro",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Jiló",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 2,
            "price": 14
          },
          {
            "name": "Geleia de uva",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Chicória",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Beterraba",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1542
      },
      {
        "deliveryId": "WwHy88JbxqL9fnThBPua",
        "date": "2024-10-17",
        "dateText": "16/10/2024",
        "cestas": 12,
        "totalAmountBaseProductsSale": 540,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 30
          },
          {
            "name": "Cebolinha",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Jiló",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Tomatinho",
            "amount": 10,
            "price": 6
          },
          {
            "name": "Caju",
            "amount": 4,
            "price": 10
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 14
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Colorau 150g",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mamão Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 4,
            "price": 40
          },
          {
            "name": "Brócolis ",
            "amount": 6,
            "price": 6
          },
          {
            "name": "Vagem",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Bolo de laranja",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Alface",
            "amount": 1,
            "price": 6
          },
          {
            "name": "1/2 queijo meia cura",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 7,
            "price": 15
          },
          {
            "name": "Açafrão grão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Repolho ",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 954
      },
      {
        "deliveryId": "6gwMZbVyzk03zTUwc1l7",
        "date": "2024-11-07",
        "dateText": "06/11/2024",
        "cestas": 10,
        "totalAmountBaseProductsSale": 450,
        "extraProducts": [
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Tomatinho",
            "amount": 4,
            "price": 6
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 5,
            "price": 30
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 4,
            "price": 14
          },
          {
            "name": "Jiló",
            "amount": 5,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 6,
            "price": 15
          },
          {
            "name": "1/2 queijo meia cura",
            "amount": 4,
            "price": 20
          },
          {
            "name": "Maxixe",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 4,
            "price": 40
          },
          {
            "name": "Rosca de Côco com recheio de goiabada",
            "amount": 2,
            "price": 18
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Cenoura",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Mamão Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Babosa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Suco de manga",
            "amount": 3,
            "price": 19
          },
          {
            "name": "Feijão 1Kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Caxi",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Abobrinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Vagem",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1047
      },
      {
        "deliveryId": "cXUKya5qywYleSchy1E5",
        "date": "2024-11-21",
        "dateText": "20/11/2024",
        "cestas": 9,
        "totalAmountBaseProductsSale": 405,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 4,
            "price": 40
          },
          {
            "name": "Rosca de Côco com recheio de goiabada",
            "amount": 2,
            "price": 18
          },
          {
            "name": "Caxi",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Tomatinho",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cenoura",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Rabanete",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Farinha de mandioca Lió 500g",
            "amount": 2,
            "price": 8
          },
          {
            "name": "Ovos (dúzia)sujeito a pouco estoque ",
            "amount": 7,
            "price": 15
          },
          {
            "name": "Pão integral",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Rosquinha recheada de goiabada",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Abobrinha",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 4,
            "price": 14
          },
          {
            "name": "Feijão 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Hortelã",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Suco de manga",
            "amount": 3,
            "price": 19
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 19
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 17
          },
          {
            "name": "Berinjela",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Maxixe",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Acerola",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 30
          }
        ],
        "totalAmountExtraProductsSales": 924
      },
      {
        "deliveryId": "i5VjGubBLCDFKf79cVFz",
        "date": "2024-12-05",
        "dateText": "04/12/2024",
        "cestas": 15,
        "totalAmountBaseProductsSale": 675,
        "extraProducts": [
          {
            "name": "1/2 queijo meia cura",
            "amount": 4,
            "price": 22
          },
          {
            "name": "Contribuição de Natal 🎄",
            "amount": 23,
            "price": 20
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 14
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Feijão 1Kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Ovos (dúzia)sujeito a pouco estoque ",
            "amount": 9,
            "price": 15
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 3,
            "price": 22
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Manga",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Maxixe",
            "amount": 1,
            "price": 6
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 7,
            "price": 30
          },
          {
            "name": "Farinha de mandioca (normal) 1kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Espinafre",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Nózinho de Coco",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Caxi",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 55
          }
        ],
        "totalAmountExtraProductsSales": 1482
      },
      {
        "deliveryId": "iMVSNWvZxF8HwVOQYx7b",
        "date": "2024-12-19",
        "dateText": "18/12/2024",
        "cestas": 17,
        "totalAmountBaseProductsSale": 765,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 4,
            "price": 30
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 30
          },
          {
            "name": "Contribuição de Natal 🎄",
            "amount": 24,
            "price": 20
          },
          {
            "name": "1/2 queijo meia cura",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Geleia de uva",
            "amount": 3,
            "price": 18
          },
          {
            "name": "Jiló",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Queijo Fresco P",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Quiabo",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 5,
            "price": 40
          },
          {
            "name": "Suco de manga",
            "amount": 4,
            "price": 19
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 3,
            "price": 19
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro tradicional",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Abacaxi",
            "amount": 7,
            "price": 7
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Bonés bordados",
            "amount": 1,
            "price": 60
          },
          {
            "name": "Cachaça prata",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Pão integral",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Rosquinha recheada de goiabada",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 4,
            "price": 14
          },
          {
            "name": "Limão ",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 14
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 22
          }
        ],
        "totalAmountExtraProductsSales": 1615
      },
      {
        "deliveryId": "9VJMui5fWDi1keSC8DdX",
        "date": "2025-01-09",
        "dateText": "08/01/2025",
        "cestas": 10,
        "totalAmountBaseProductsSale": 450,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 33
          },
          {
            "name": "Alho-poró",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)sujeito a pouco estoque ",
            "amount": 6,
            "price": 18
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 3,
            "price": 40
          },
          {
            "name": "Suco de manga",
            "amount": 3,
            "price": 19
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Cenoura",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cheiro Verde",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Molho de Pimenta",
            "amount": 3,
            "price": 10
          },
          {
            "name": "Chuchu",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Manga",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Quiabo",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cachaça carvalho",
            "amount": 1,
            "price": 45
          }
        ],
        "totalAmountExtraProductsSales": 837
      },
      {
        "deliveryId": "Jk6rvfsWKwwCgP8GxunE",
        "date": "2025-01-23",
        "dateText": "22/01/2025",
        "cestas": 9,
        "totalAmountBaseProductsSale": 405,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 4,
            "price": 33
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 14,
            "price": 18
          },
          {
            "name": "Maracujá",
            "amount": 4,
            "price": 7
          },
          {
            "name": "1/2 queijo meia cura",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Banana 1 kg",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 38
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 3,
            "price": 22
          },
          {
            "name": "Tomatinho",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Abacaxi",
            "amount": 9,
            "price": 7
          },
          {
            "name": "Cenoura",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Farinha de mandioca Lió 500g",
            "amount": 1,
            "price": 8
          },
          {
            "name": "Milho 1/2 dz",
            "amount": 5,
            "price": 9
          },
          {
            "name": "Pão de beterraba",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 28
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Couve",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Limão ",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Abobrinha",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Alface",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 9
          },
          {
            "name": "Chicória",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 19
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Colorau 150g",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 38
          }
        ],
        "totalAmountExtraProductsSales": 1243
      },
      {
        "deliveryId": "2sZcKMd1PPiKc8qNCv1b",
        "date": "2025-02-06",
        "dateText": "05/02/2025",
        "cestas": 13,
        "totalAmountBaseProductsSale": 585,
        "extraProducts": [
          {
            "name": "1/2 queijo meia cura",
            "amount": 3,
            "price": 22
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 38
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 33
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 5,
            "price": 38
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 8,
            "price": 18
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 19
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 19
          },
          {
            "name": "Couve",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Limão ",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Abacaxi",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Queijo Fresco P",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Caxi",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Alface",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Manga",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Farinha de mandioca artesanal do Lió",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Alho-poró",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Quiabo",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Beterraba",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Maracujá",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Manjericão",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1054
      },
      {
        "deliveryId": "QvTD5UCvlsaHasLWJ6Vl",
        "date": "2025-02-20",
        "dateText": "19/02/2025",
        "cestas": 12,
        "totalAmountBaseProductsSale": 540,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 4,
            "price": 33
          },
          {
            "name": "Quiabo",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Pitaya",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Couve",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 10,
            "price": 18
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Milho 1/2 dz",
            "amount": 2,
            "price": 9
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Abacaxi",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Caxi",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Taioba",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Feijão de corda",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Molho de Pimenta 150ML",
            "amount": 1,
            "price": 10
          }
        ],
        "totalAmountExtraProductsSales": 474
      },
      {
        "deliveryId": "Hk4mQXvQh5IdtKK44g6T",
        "date": "2025-03-06",
        "dateText": "05/03/2025",
        "cestas": 12,
        "totalAmountBaseProductsSale": 540,
        "extraProducts": [
          {
            "name": "Caxixe",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 10,
            "price": 18
          },
          {
            "name": "Milho 1/2 dz",
            "amount": 4,
            "price": 9
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 40
          },
          {
            "name": "Limão ",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 4,
            "price": 42
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 3,
            "price": 21
          },
          {
            "name": "Suco de manga",
            "amount": 4,
            "price": 21
          },
          {
            "name": "1/2 queijo meia cura",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 3,
            "price": 21
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Queijo Fresco P",
            "amount": 1,
            "price": 24
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Farinha de mandioca Lió 500g",
            "amount": 2,
            "price": 8
          },
          {
            "name": "Molho de Pimenta 150ML",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Alho-poró",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Farinha de mandioca artesanal do Lió",
            "amount": 1,
            "price": 15
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 2,
            "price": 33
          },
          {
            "name": "Abacate",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 4,
            "price": 24
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Taioba",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz Branco 5kg",
            "amount": 1,
            "price": 67
          }
        ],
        "totalAmountExtraProductsSales": 1317
      },
      {
        "deliveryId": "Fr708y0BjZA6EJ4nbQTj",
        "date": "2025-03-20",
        "dateText": "19/03/2025",
        "cestas": 13,
        "totalAmountBaseProductsSale": 585,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 5,
            "price": 33
          },
          {
            "name": "Abacate",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 9
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 11,
            "price": 18
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 21
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 21
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 3,
            "price": 21
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 24
          },
          {
            "name": "Cenoura",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Limão ",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Quiabo",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Farinha de mandioca Lió 500g",
            "amount": 4,
            "price": 8
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Taioba",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pão integral",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 33
          }
        ],
        "totalAmountExtraProductsSales": 856
      },
      {
        "deliveryId": "4Bn35SW59XK1vD07ThGL",
        "date": "2025-04-03",
        "dateText": "02/04/2025",
        "cestas": 7,
        "totalAmountBaseProductsSale": 315,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 16,
            "price": 33
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 40
          },
          {
            "name": "Farinha de mandioca Lió 500g",
            "amount": 1,
            "price": 8
          },
          {
            "name": "Limão ",
            "amount": 7,
            "price": 7
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 14,
            "price": 18
          },
          {
            "name": "Quiabo",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 21
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 21
          },
          {
            "name": "Alface",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Fubá de milho 500grs ",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Amendoim",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Mamão",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Arroz Branco parborizado  5kg",
            "amount": 1,
            "price": 67
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Pão de beterraba",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Maracujá",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Maxixe",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Pão comum",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Café Guai",
            "amount": 1,
            "price": 40
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 21
          }
        ],
        "totalAmountExtraProductsSales": 1461
      },
      {
        "deliveryId": "gYBL5xRFgJOcOmCGLa35",
        "date": "2025-04-17",
        "dateText": "16/04/2025",
        "cestas": 11,
        "totalAmountBaseProductsSale": 495,
        "extraProducts": [
          {
            "name": "Maracujá",
            "amount": 7,
            "price": 7
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 7,
            "price": 33
          },
          {
            "name": "1/2 queijo meia cura",
            "amount": 5,
            "price": 24
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 4,
            "price": 20
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 15,
            "price": 18
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 21
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 21
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 5,
            "price": 24
          },
          {
            "name": "Mamão Verde",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 9
          },
          {
            "name": "Quiabo",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 42
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 33
          },
          {
            "name": "Rúcula",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Suco de uva 1L",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Abacate",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Queijo Fresco P",
            "amount": 1,
            "price": 24
          }
        ],
        "totalAmountExtraProductsSales": 1320
      },
      {
        "deliveryId": "AuAsjAp6r0VJSrx7c3EA",
        "date": "2025-05-08",
        "dateText": "07/05/2025",
        "cestas": 7,
        "totalAmountBaseProductsSale": 315,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 8,
            "price": 33
          },
          {
            "name": "Alface",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Cenoura",
            "amount": 6,
            "price": 7
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 10,
            "price": 18
          },
          {
            "name": "Maracujá",
            "amount": 6,
            "price": 7
          },
          {
            "name": "Nózinho de Coco",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Rifa Juninho ",
            "amount": 11,
            "price": 10
          },
          {
            "name": "Rúcula",
            "amount": 8,
            "price": 7
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Quiabo",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tomatinho",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Flocão de Milho",
            "amount": 1,
            "price": 9
          },
          {
            "name": "Farinha de mandioca artesanal 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Mamão",
            "amount": 2,
            "price": 10
          }
        ],
        "totalAmountExtraProductsSales": 964
      },
      {
        "deliveryId": "5YSNpOkRkKqAjp9PlKNX",
        "date": "2025-05-22",
        "dateText": "21/05/2025",
        "cestas": 12,
        "totalAmountBaseProductsSale": 540,
        "extraProducts": [
          {
            "name": "Alface",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Banana 1 kg",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Chicória",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Beterraba",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Mamão",
            "amount": 3,
            "price": 10
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 9
          },
          {
            "name": "Espinafre",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Capim santo",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Melissa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Pão de beterraba",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Tomatinho",
            "amount": 3,
            "price": 7
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 33
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 40
          },
          {
            "name": "Limão ",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Nózinho de Coco",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 11,
            "price": 18
          },
          {
            "name": "Couve",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Pitaya",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Quiabo",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Cachaça carvalho",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Abacate",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Mamão Verde",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Rúcula",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 989
      },
      {
        "deliveryId": "ti0Ky7lXP7mzuqjPbMAk",
        "date": "2025-06-05",
        "dateText": "04/06/2025",
        "cestas": 13,
        "totalAmountBaseProductsSale": 585,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 8,
            "price": 33
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Limão ",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 33
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 15,
            "price": 18
          },
          {
            "name": "Taioba",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Tomatinho",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Vagem",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Chicória",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Flocão de Milho",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Mamão",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Queijo Fresco P",
            "amount": 3,
            "price": 24
          },
          {
            "name": "Quiabo",
            "amount": 5,
            "price": 7
          },
          {
            "name": "1/2 queijo meia cura",
            "amount": 3,
            "price": 24
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Capim santo",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Pão de beterraba",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Chuchu",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Farinha de mandioca Lió 500g",
            "amount": 2,
            "price": 8
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 45
          },
          {
            "name": "Abóbora",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Cenoura",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Mamão Verde",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Beterraba",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 4,
            "price": 20
          },
          {
            "name": "Cheiro Verde",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 42
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Nabo",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Pão integral",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Banana 1 kg",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Pão de mandioca",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 9
          },
          {
            "name": "Espinafre",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cachaça carvalho",
            "amount": 1,
            "price": 50
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 1620
      },
      {
        "deliveryId": "BrYQJJzL7WU17FAO5hHC",
        "date": "2025-06-19",
        "dateText": "18/06/2025",
        "cestas": 11,
        "totalAmountBaseProductsSale": 495,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 8,
            "price": 33
          },
          {
            "name": "Abobrinha G",
            "amount": 4,
            "price": 10
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 12,
            "price": 18
          },
          {
            "name": "Rúcula",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Taioba",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Vagem",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Coentro",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Tomatinho",
            "amount": 8,
            "price": 7
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Feijão 1Kg",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Flocão de Milho",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Beterraba",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Chuchu",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Maracujá",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Abobrinha",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Queijo Fresco P",
            "amount": 2,
            "price": 24
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Fubá de milho 500grs ",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Quiabo",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 946
      },
      {
        "deliveryId": "ItR3lv7u4BnmKpCJn6hz",
        "date": "2025-07-03",
        "dateText": "02/07/2025",
        "cestas": 6,
        "totalAmountBaseProductsSale": 270,
        "extraProducts": [
          {
            "name": "Alho-poró",
            "amount": 4,
            "price": 7
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 5,
            "price": 33
          },
          {
            "name": "Limão ",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Maracujá",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 9,
            "price": 18
          },
          {
            "name": "Vagem",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 9
          },
          {
            "name": "Pão de beterraba",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Queijo meia cura 1/2 P",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Tomatinho",
            "amount": 6,
            "price": 7
          },
          {
            "name": "Queijo Fresco P",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Rabanete",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Cachaça cubana",
            "amount": 1,
            "price": 50
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Feijão carioca 1Kg",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Coentro",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Feijão preto 1 kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Nabo",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Inhame",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 821
      },
      {
        "deliveryId": "ZmYkAgMjC0zaOKoiqopE",
        "date": "2025-07-17",
        "dateText": "16/07/2025",
        "cestas": 8,
        "totalAmountBaseProductsSale": 360,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 8,
            "price": 33
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 45
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 15,
            "price": 18
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Feijão preto 1 kg",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Maracujá",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Queijo Fresco P",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Capim santo",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Queijo meia cura 1/2 P",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 9
          },
          {
            "name": "Tomatinho",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Colorau 150g",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Banana 1 kg",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Berinjela",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1116
      },
      {
        "deliveryId": "Zphwrk4pjGoCWyk6r7Cf",
        "date": "2025-08-07",
        "dateText": "06/08/2025",
        "cestas": 11,
        "totalAmountBaseProductsSale": 495,
        "extraProducts": [
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Couve",
            "amount": 6,
            "price": 7
          },
          {
            "name": "Espinafre",
            "amount": 6,
            "price": 7
          },
          {
            "name": "Feijão carioca 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Feijão preto 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Mandioca sem casca",
            "amount": 5,
            "price": 9
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 13,
            "price": 18
          },
          {
            "name": "Rúcula",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Tomatinho",
            "amount": 9,
            "price": 7
          },
          {
            "name": "Berinjela",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Farinha de mandioca Lió 500g",
            "amount": 1,
            "price": 8
          },
          {
            "name": "Limão ",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 45
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 7,
            "price": 33
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Nabo",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Cachaça cubana",
            "amount": 1,
            "price": 50
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Banana 1 kg",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Tempero caseiro coentro",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Beterraba",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Queijo Fresco P",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 1,
            "price": 25
          }
        ],
        "totalAmountExtraProductsSales": 1485
      },
      {
        "deliveryId": "5onv2DZwrlEup2khDIoA",
        "date": "2025-08-21",
        "dateText": "20/08/2025",
        "cestas": 5,
        "totalAmountBaseProductsSale": 225,
        "extraProducts": [
          {
            "name": "Feijão carioca 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Feijão preto 1 kg",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Tomatinho",
            "amount": 15,
            "price": 7
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 13,
            "price": 18
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 14,
            "price": 33
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Banana 1 kg",
            "amount": 7,
            "price": 7
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Alho-poró",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Farinha de mandioca Lió 500g",
            "amount": 2,
            "price": 8
          },
          {
            "name": "Nabo",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Nózinho de Coco",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Berinjela",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Cheiro Verde",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Pimenta do reino moída",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Repolho ",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Chicória",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de laranja",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 9
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 3,
            "price": 22
          }
        ],
        "totalAmountExtraProductsSales": 1426
      },
      {
        "deliveryId": "L4tW0gXHNCsZy8SCWQkM",
        "date": "2025-09-04",
        "dateText": "03/09/2025",
        "cestas": 12,
        "totalAmountBaseProductsSale": 540,
        "extraProducts": [
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Banana 1 kg",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Cheiro Verde",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Tomatinho",
            "amount": 9,
            "price": 7
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 33
          },
          {
            "name": "Nózinho de Coco",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Bolo de laranja",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 15,
            "price": 18
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 3,
            "price": 25
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Nabo",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Feijão carioca 1Kg",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Feijão preto 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Mandioca sem casca",
            "amount": 4,
            "price": 9
          },
          {
            "name": "Frango caipira",
            "amount": 1,
            "price": 60
          },
          {
            "name": "Queijo Fresco P",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Alho-poró",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Queijo meia cura 1/2 P",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 1467
      },
      {
        "deliveryId": "BSCQleZyltofNFcN2lrp",
        "date": "2025-09-18",
        "dateText": "17/09/2025",
        "cestas": 7,
        "totalAmountBaseProductsSale": 315,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 33
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 45
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Queijo meia cura 1/2 P",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Tomatinho",
            "amount": 11,
            "price": 7
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Vagem",
            "amount": 7,
            "price": 7
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 7,
            "price": 18
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Tempero caseiro pimenta",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Feijão preto 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Berinjela",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 9
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Limão ",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 1074
      },
      {
        "deliveryId": "yNAVC8rMdCzHO1h9imFC",
        "date": "2025-10-02",
        "dateText": "01/10/2025",
        "cestas": 8,
        "totalAmountBaseProductsSale": 360,
        "extraProducts": [
          {
            "name": "Berinjela",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 9,
            "price": 18
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Couve",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 9
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Tomatinho",
            "amount": 7,
            "price": 7
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 5,
            "price": 33
          },
          {
            "name": "Abobrinha",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Feijão preto 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Pimentão",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Jabuticaba",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Repolho ",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Feijão carioca 1Kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 33
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Flocão de Milho 500 gr",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 1,
            "price": 25
          }
        ],
        "totalAmountExtraProductsSales": 837
      },
      {
        "deliveryId": "pmsT3L98diCmFHdu2Bmw",
        "date": "2025-10-16",
        "dateText": "15/10/2025",
        "cestas": 10,
        "totalAmountBaseProductsSale": 450,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 33
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 4,
            "price": 45
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 8,
            "price": 18
          },
          {
            "name": "Bolo de laranja",
            "amount": 2,
            "price": 30
          },
          {
            "name": "Geleia de manga com maracujá ",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Alho-poró",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Tomatinho",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Mandioca sem casca",
            "amount": 3,
            "price": 9
          },
          {
            "name": "Maxixe",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Pimentão",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Feijão carioca 1Kg",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Abobrinha",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Espinafre",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cenoura",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Alface",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Berinjela",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 981
      },
      {
        "deliveryId": "C1u7Q74mTRbNpzgAZQFp",
        "date": "2025-11-06",
        "dateText": "05/11/2025",
        "cestas": 8,
        "totalAmountBaseProductsSale": 360,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 10,
            "price": 33
          },
          {
            "name": "Alho-poró",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 9
          },
          {
            "name": "Pão de beterraba",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cheiro Verde",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Couve",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 11,
            "price": 18
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Repolho ",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Vagem",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Queijo meia cura 1/2 P",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Pimentão",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Melissa",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Queijo Fresco P",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Feijão carioca 1Kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Espinafre",
            "amount": 2,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 1066
      },
      {
        "deliveryId": "NuearNeVTOVpixrOOKrb",
        "date": "2025-11-20",
        "dateText": "19/11/2025",
        "cestas": 8,
        "totalAmountBaseProductsSale": 360,
        "extraProducts": [
          {
            "name": "Couve",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Beterraba",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Chicória",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Espinafre",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 1,
            "price": 7
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 5,
            "price": 33
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 2,
            "price": 18
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Queijo Fresco P",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Maxixe",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Abacaxi",
            "amount": 1,
            "price": 10
          },
          {
            "name": "Abobrinha",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Tomatinho",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 22
          }
        ],
        "totalAmountExtraProductsSales": 574
      },
      {
        "deliveryId": "NVaIBHra0vRI8YWoQuWd",
        "date": "2025-12-04",
        "dateText": "03/12/2025",
        "cestas": 11,
        "totalAmountBaseProductsSale": 495,
        "extraProducts": [
          {
            "name": "Contribuição de Natal 🎄",
            "amount": 27,
            "price": 20
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 13,
            "price": 18
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 11,
            "price": 33
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Feijão carioca 1Kg",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Cheiro Verde",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 3,
            "price": 20
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Queijo meia cura 1/2 P",
            "amount": 5,
            "price": 25
          },
          {
            "name": "Capim santo",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Rosquinha recheada de goiabada",
            "amount": 4,
            "price": 15
          },
          {
            "name": "Alface",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Lichia",
            "amount": 6,
            "price": 7
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Suco de goiaba 1L",
            "amount": 3,
            "price": 22
          },
          {
            "name": "Suco de maçã 1L",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Arroz Cateto integral 1 kg",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Colorau (100g)",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Queijo Fresco P",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Espinafre",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Suco de manga",
            "amount": 1,
            "price": 22
          },
          {
            "name": "Alho-poró",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Almeirão",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Bolo de milho",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Pimenta do Reino em grãos ",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 2091
      },
      {
        "deliveryId": "RdTN78pWAAsrPtWAGSvb",
        "date": "2025-12-18",
        "dateText": "17/12/2025",
        "cestas": 6,
        "totalAmountBaseProductsSale": 270,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 9,
            "price": 33
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Erva-doce",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mandioca sem casca",
            "amount": 3,
            "price": 9
          },
          {
            "name": "Contribuição de Natal 🎄",
            "amount": 18,
            "price": 15
          },
          {
            "name": "Berinjela",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Cachaça amburana",
            "amount": 2,
            "price": 50
          },
          {
            "name": "Abacaxi",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Lichia",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Manga",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 3,
            "price": 18
          },
          {
            "name": "Taioba",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 45
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Espinafre",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 33
          }
        ],
        "totalAmountExtraProductsSales": 1163
      },
      {
        "deliveryId": "EWV7YCoF4rcpnY1flvSI",
        "date": "2026-01-08",
        "dateText": "07/01/2026",
        "cestas": 8,
        "totalAmountBaseProductsSale": 360,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 33
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Abacaxi",
            "amount": 8,
            "price": 10
          },
          {
            "name": "Acerola",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Quiabo",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 7,
            "price": 18
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Suco de manga",
            "amount": 2,
            "price": 22
          },
          {
            "name": "Limão ",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 9
          },
          {
            "name": "Maxixe",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Frango caipira",
            "amount": 1,
            "price": 60
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Taioba",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Arroz Branco agulhinha  5kg",
            "amount": 1,
            "price": 67
          }
        ],
        "totalAmountExtraProductsSales": 874
      },
      {
        "deliveryId": "cWVPlWs9ZCnx1CboCT3P",
        "date": "2026-01-22",
        "dateText": "21/01/2026",
        "cestas": 8,
        "totalAmountBaseProductsSale": 360,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 4,
            "price": 33
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 2,
            "price": 20
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Tomatinho",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Arroz integral 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Flocão de Milho 500 gr",
            "amount": 2,
            "price": 12
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 9
          },
          {
            "name": "Ovos (dúzia)sujeito pouco estoque ",
            "amount": 4,
            "price": 18
          },
          {
            "name": "Quiabo",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Abacaxi",
            "amount": 5,
            "price": 10
          },
          {
            "name": "Batata Doce",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cachaça vida seca",
            "amount": 1,
            "price": 50
          },
          {
            "name": "Ovos (dúzia)",
            "amount": 1,
            "price": 18
          },
          {
            "name": "Abóbora",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Erva-doce folhas ",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 618
      },
      {
        "deliveryId": "HwH7pZpc8hsH5kE21KjQ",
        "date": "2026-02-05",
        "dateText": "04/02/2026",
        "cestas": 10,
        "totalAmountBaseProductsSale": 450,
        "extraProducts": [
          {
            "name": "Abacate",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Banana 1 kg",
            "amount": 7,
            "price": 7
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Couve",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Limão ",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Mandioca sem casca",
            "amount": 4,
            "price": 9
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 33
          },
          {
            "name": "Cheiro Verde",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Maxixe",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Tomatinho",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 3,
            "price": 45
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Abóbora",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Caxi",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Café Guai",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Pepino (em natura)",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Pimentão",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Beterraba",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Feijão carioca 1Kg",
            "amount": 1,
            "price": 15
          }
        ],
        "totalAmountExtraProductsSales": 805
      },
      {
        "deliveryId": "D8XLVGSoRteMONEUXWFw",
        "date": "2026-02-19",
        "dateText": "18/02/2026",
        "cestas": 9,
        "totalAmountBaseProductsSale": 405,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 5,
            "price": 33
          },
          {
            "name": "Caxixe",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Vagem",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Suco de uva 1,5 litro",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Milho 1/2 dz",
            "amount": 6,
            "price": 9
          },
          {
            "name": "Beterraba",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Espinafre",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Pão de mandioca",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Abacate",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Tomatinho",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Limão ",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Alho-poró",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Quiabo",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Broa de fubá 100g ",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Taioba",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Pão de beterraba",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Berinjela",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Mandioca sem casca",
            "amount": 1,
            "price": 9
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 577
      },
      {
        "deliveryId": "4ZlzGm7bEt3RSJ58YLAp",
        "date": "2026-03-05",
        "dateText": "04/03/2026",
        "cestas": 11,
        "totalAmountBaseProductsSale": 495,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 33
          },
          {
            "name": "Abacate",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Ovos (dúzia)sujeito pouco estoque ",
            "amount": 5,
            "price": 18
          },
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Queijo Fresco P",
            "amount": 4,
            "price": 25
          },
          {
            "name": "Broa de fubá 100g ",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Rabanete",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Tomatinho",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Banana 1 kg",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Quiabo",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Abóbora",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Pitomba 350gr ",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Queijo meia cura 1/2 P",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 50
          },
          {
            "name": "Alface",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 922
      },
      {
        "deliveryId": "l6itIw5vZbGh45jXZCPc",
        "date": "2026-03-19",
        "dateText": "18/03/2026",
        "cestas": 6,
        "totalAmountBaseProductsSale": 270,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 10,
            "price": 33
          },
          {
            "name": "Quiabo",
            "amount": 8,
            "price": 7
          },
          {
            "name": "Mandioca sem casca",
            "amount": 5,
            "price": 9
          },
          {
            "name": "Vagem",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Bolo de cenoura com cobertura",
            "amount": 1,
            "price": 30
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Ovos (dúzia)sujeito pouco estoque ",
            "amount": 6,
            "price": 18
          },
          {
            "name": "Pão de mandioca",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Queijo Fresco P",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Capim santo",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Abacate",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Cajamanga",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Alface",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Colorau 150g",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Queijo meia cura 1/2 P",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Pimentão",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Abóbora",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Rabanete",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Pão de fubá ",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Abóbora moranga inteira (7 reais por kg)",
            "amount": 7,
            "price": 7
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Tomatinho",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Pão integral",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Taioba",
            "amount": 1,
            "price": 6
          }
        ],
        "totalAmountExtraProductsSales": 1059
      },
      {
        "deliveryId": "2IoGGLPGtIWDVutokYXB",
        "date": "2026-04-02",
        "dateText": "01/04/2026",
        "cestas": 10,
        "totalAmountBaseProductsSale": 450,
        "extraProducts": [
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 33
          },
          {
            "name": "Alho-poró",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Milho 1/2 dz",
            "amount": 6,
            "price": 9
          },
          {
            "name": "Quiabo",
            "amount": 7,
            "price": 7
          },
          {
            "name": "Alface",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Cenoura",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Mandioca sem casca",
            "amount": 3,
            "price": 9
          },
          {
            "name": "Tomatinho",
            "amount": 6,
            "price": 7
          },
          {
            "name": "Banana 1 kg",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Flocão de Milho 500 gr",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Pitomba 350gr ",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Repolho ",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Rúcula",
            "amount": 5,
            "price": 7
          },
          {
            "name": "Cachaça amburana",
            "amount": 1,
            "price": 50
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Limão ",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Vagem",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Fubá de milho 1kg",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Salsinha",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 825
      },
      {
        "deliveryId": "pdLcoGpY7W7HOxrcV7pe",
        "date": "2026-04-16",
        "dateText": "15/04/2026",
        "cestas": 8,
        "totalAmountBaseProductsSale": 360,
        "extraProducts": [
          {
            "name": "Queijo Fresco P",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Limão ",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Alface",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Couve",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Espinafre",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Ovos (dúzia)sujeito pouco estoque ",
            "amount": 4,
            "price": 18
          },
          {
            "name": "Quiabo",
            "amount": 7,
            "price": 7
          },
          {
            "name": "Berinjela",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Chuchu",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Banana 1 kg",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Abacate",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Alho-poró",
            "amount": 3,
            "price": 7
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 7,
            "price": 33
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Colorau 150g",
            "amount": 1,
            "price": 12
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 3,
            "price": 45
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 9
          },
          {
            "name": "Salsinha",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Rúcula",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Cebolinha",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 871
      },
      {
        "deliveryId": "vvGuOhGVPdOQGPUGvXTC",
        "date": "2026-05-07",
        "dateText": "06/05/2026",
        "cestas": 11,
        "totalAmountBaseProductsSale": 495,
        "extraProducts": [
          {
            "name": "Pão de mandioca",
            "amount": 3,
            "price": 15
          },
          {
            "name": "Alface",
            "amount": 4,
            "price": 6
          },
          {
            "name": "Cebolinha",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Chicória",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Salsinha",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Bolo de fubá com erva doce",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Pão integral",
            "amount": 1,
            "price": 15
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 33
          },
          {
            "name": "Bolo de cenoura",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Rosca de Côco com recheio de goiabada",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Abacate",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Alho-poró",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Espinafre",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Maracujá",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Capim santo",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Mamão inteiro ",
            "amount": 2,
            "price": 10
          },
          {
            "name": "Taioba",
            "amount": 2,
            "price": 6
          },
          {
            "name": "Cheiro Verde",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Cenoura",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Broa de fubá 300g",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Colorau (100g)",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 550
      },
      {
        "deliveryId": "1bhbqsVJvbeNMVNTnVp5",
        "date": "2026-05-21",
        "dateText": "20/05/2026",
        "cestas": 7,
        "totalAmountBaseProductsSale": 315,
        "extraProducts": [
          {
            "name": " CESTA PEQUENA",
            "amount": 6,
            "price": 33
          },
          {
            "name": "Bolinho de Chuva",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Queijo Fresco P",
            "amount": 2,
            "price": 25
          },
          {
            "name": "Nózinho de Coco",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Banana 1 kg",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Limão ",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Cachaça carvalho",
            "amount": 1,
            "price": 50
          },
          {
            "name": "Mandioca (com casca)",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Beterraba",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Rúcula",
            "amount": 4,
            "price": 7
          },
          {
            "name": "Alface",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Alho-poró",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Cheiro Verde",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Couve",
            "amount": 1,
            "price": 7
          }
        ],
        "totalAmountExtraProductsSales": 579
      },
      {
        "deliveryId": "VBNDN8Y86sAsDaeF9nnm",
        "date": "2026-06-04",
        "dateText": "03/06/2026",
        "cestas": 5,
        "totalAmountBaseProductsSale": 225,
        "extraProducts": [
          {
            "name": "Queijo Meia Cura G",
            "amount": 2,
            "price": 45
          },
          {
            "name": "Mandioca sem casca",
            "amount": 2,
            "price": 9
          },
          {
            "name": "Café Cecília (grãos)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Molho de Tomate",
            "amount": 1,
            "price": 33
          },
          {
            "name": "Cheiro Verde",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Pão integral",
            "amount": 2,
            "price": 15
          },
          {
            "name": " CESTA PEQUENA",
            "amount": 8,
            "price": 33
          },
          {
            "name": "Couve",
            "amount": 3,
            "price": 7
          },
          {
            "name": "Alface",
            "amount": 3,
            "price": 6
          },
          {
            "name": "Ovos (dúzia)sujeito pouco estoque ",
            "amount": 2,
            "price": 18
          },
          {
            "name": "Quiabo",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Tomatinho",
            "amount": 6,
            "price": 7
          },
          {
            "name": "Espinafre",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Banana 1 kg",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Limão ",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Queijo meia cura 1/2 P",
            "amount": 1,
            "price": 25
          },
          {
            "name": "Vagem",
            "amount": 2,
            "price": 7
          },
          {
            "name": "Arroz branco 1kg",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Café Cecília (moído)",
            "amount": 1,
            "price": 45
          },
          {
            "name": "Feijão preto 1 kg",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Geleia de amora",
            "amount": 1,
            "price": 20
          },
          {
            "name": "Nózinho de Coco",
            "amount": 2,
            "price": 15
          },
          {
            "name": "Pão de mandioca",
            "amount": 1,
            "price": 15
          },
          {
            "name": "Alecrim",
            "amount": 1,
            "price": 6
          },
          {
            "name": "Abacate",
            "amount": 1,
            "price": 7
          },
          {
            "name": "Cachaça prata",
            "amount": 1,
            "price": 50
          },
          {
            "name": "Bolo de mandioca",
            "amount": 1,
            "price": 30
          }
        ],
        "totalAmountExtraProductsSales": 937
      }
    ]
  }
}